import {
  ChevronDown,
  ChevronUp,
  Copy,
  Folder,
  MoreVertical,
  Trash,
} from 'react-feather'
import { useDispatch, useSelector } from 'react-redux'
import {
  Card,
  CardBody,
  Col,
  Collapse,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
  Row,
  UncontrolledDropdown,
  UncontrolledTooltip,
} from 'reactstrap'

import AmountInput from 'components/AmountInput'
import CustomButton from 'components/Buttons/CustomButton'
import Skeleton from 'components/Skeleton'
import PMBInputNumber from 'components/PMBInputNumber'
import PMBSelect from 'components/PMBSelect'
import {
  fetchInventoryGroups,
  getInventory,
} from 'features/public-views/manageStock/API/manageStockAction'
import useAutoFetchPublicVersion from 'hooks/useAutoFetchPublicVersion'
import { useEffect, useRef, useState } from 'react'
import { useIntl } from 'react-intl'
import { newFormatThousandSeparator } from 'utils/formatNumber'
import {
  getComodities,
  getInventories,
  getPackings,
} from '../sellCommodityAction'
import {
  removeItem,
  removePacking,
  resetItemToDefault,
  setInvPacking,
  updateInvPacking,
  setItemCount,
  setOrdersPayload,
} from '../sellCommoditySlice'
import ModalAutoPick from './ModalAutoPick'
import ModalGroupItemPicker from './ModalGroupItemPicker'
import ModalSplit from './ModalSplit'
import PriceReference from './PriceReference'

const Item2 = ({
  fieldNum,
  idx,
  refItem,
  invToTrx,
  isInventory,
  setIsInventory,
  setItemLoading,
}) => {
  const dispatch = useDispatch()
  const intl = useIntl()
  const autoFetchPublicVersion = useAutoFetchPublicVersion()

  const {
    orders,
    addItemCount,
    comodities,
    inventories,
    packings,
    invPacking,
    isLoading,
  } = useSelector((state) => state.sellCommodity)
  const { profile } = useSelector((state) => state.dashboard)
  const [units, setUnits] = useState([])
  const [listComodities, setListComodities] = useState(comodities || [])
  const [listInventories, setListInventories] = useState([
    {
      label: 'GRUP INVENTORI',
      options: packings?.length
        ? packings.map((e) => ({
            label: e?.nameItem,
            ...e,
          }))
        : [],
    },
    {
      label: 'SEMUA INVENTORI',
      options: inventories?.length
        ? inventories.map((e) => ({
            label: e?.nameItem,
            ...e,
          }))
        : [],
    },
  ])
  const [openOptionId, setOpenOptionId] = useState(null)
  const [loading, setLoading] = useState({
    inventory: false,
  })

  const [priceVersions, setPriceVersions] = useState({})
  const [modalSplitOpen, setModalSplitOpen] = useState(false)
  const [selectedItemForSplit, setSelectedItemForSplit] = useState(null)
  const [splitTargetContext, setSplitTargetContext] = useState(null)
  const [isSplitting, setIsSplitting] = useState(false)

  // Auto-pick modal state
  const [showAutoPickModal, setShowAutoPickModal] = useState(false)

  // Group item picker modal state
  const [showGroupPickerModal, setShowGroupPickerModal] = useState(false)
  const [pendingGroupSelection, setPendingGroupSelection] = useState(null)
  const [groupItems, setGroupItems] = useState([])
  const [initialGroupSelectedItemIds, setInitialGroupSelectedItemIds] =
    useState([])
  const [isLoadingGroupItems, setIsLoadingGroupItems] = useState(false)
  const [isWaitingAutoInventory, setIsWaitingAutoInventory] = useState(false)
  const [scannerSearchInput, setScannerSearchInput] = useState('')
  const [menuIsOpen, setMenuIsOpen] = useState(false)

  const [expandedInvGroups, setExpandedInvGroups] = useState({})
  // Ref to track which nameItem has already been processed for auto-select
  const processedNameItemRef = useRef(null)

  useEffect(() => {
    const onScannerProductSearch = (event) => {
      const productName = String(event?.detail?.productName || '').trim()
      if (!productName) return

      // Switch to 'Inventori Anda' tab automatically
      if (typeof setIsInventory === 'function') {
        setIsInventory((prev) => {
          const updated = [...prev]
          updated[idx] = true
          return updated
        })
      }

      // Reset the item slot to default for 'inventori_anda' type
      dispatch(resetItemToDefault({ type: 'inventori_anda', fieldNum }))

      // Set search value and open the dropdown
      setScannerSearchInput(productName)
      setMenuIsOpen(true)
    }

    document.addEventListener('scanner:product-search', onScannerProductSearch)
    return () => {
      document.removeEventListener(
        'scanner:product-search',
        onScannerProductSearch,
      )
    }
  }, [idx, fieldNum, setIsInventory, dispatch])

  const handleChange = (name, e, i, isInv, isPack, fromSplit = false) => {
    let key = Object.prototype.hasOwnProperty.call(e, 'sku') ? 'nameItem' : name
    let value =
      key === 'nameItem'
        ? isInv
          ? e?.nameItem || e?.label2 || e?.label
          : e.label
        : e
    let imageUrl = key === 'nameItem' ? e.img : orders?.item[i]?.imageUrl
    let sku = key === 'nameItem' ? e.sku : orders?.item[i]?.SKU
    let id = key === 'nameItem' ? e.id : orders?.item[i]?.id

    let newData = [...orders.item]

    const formattedAmount =
      typeof e.amount === 'number'
        ? intl
            .formatNumber(e.amount, {
              useGrouping: 'always',
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })
            .toString()
        : e?.amount

    newData[i] = {
      ...newData[i],
      [key]: value,
      id: id,
      SKU: sku,
      imageUrl: imageUrl,
      isPacking: isPack ?? orders?.item[i]?.isPacking ?? false,
      sourceGroupName:
        e?.sourceGroupName ||
        e?.group?.nameItem ||
        e?.group?.name ||
        e?.groupName ||
        newData[i]?.sourceGroupName,
      ...(isInv && { inventoryId: e.id }),
      ...(isInv && { itemId: e.itemId }),
      ...(isInv && { originalAmount: e?.amount }),
      ...(isInv && { amount: formattedAmount }),
      ...(isInv && {
        unit: autoFetchPublicVersion?.unitArray.find((z) => {
          const zVal = String(z?.value || '').toLowerCase()
          const eVal = String(
            e?.unit?.value || e?.unit || e?.item?.unit || '',
          ).toLowerCase()
          return zVal === eVal
        }),
      }),
      totalPrice:
        key === 'price' && orders.item[i]?.amount
          ? Number(
              value
                ?.replace(/,/g, '.')
                ?.replace(/(?<=\d)\.(?=\d{3})/g, '')
                ?.slice(0, 15),
            ) *
            Number(
              newData[i]?.amount
                ?.replace(/,/g, '.')
                ?.replace(/(?<=\d)\.(?=\d{3})/g, '')
                ?.slice(0, 15),
            )
          : key === 'amount' && orders.item[i]?.price
            ? Number(
                newData[i]?.price
                  ?.replace(/,/g, '.')
                  ?.replace(/(?<=\d)\.(?=\d{3})/g, '')
                  ?.slice(0, 15),
              ) *
              Number(
                value
                  ?.replace(/,/g, '.')
                  ?.replace(/(?<=\d)\.(?=\d{3})/g, '')
                  ?.slice(0, 15),
              )
            : newData[i]?.totalPrice,
      ...(isPack && { price: null, totalPrice: null, inventoryId: null }),
      ...(key === 'amount' && !fromSplit ? { isEdited: true } : {}),
    }

    dispatch(setOrdersPayload(newData))
  }

  const handleChangeInputSeparator = (data, name, idx, resData) => {
    const parsedData = Number(
      data?.replace?.(/\./g, '')?.replace?.(/\,/g, '.')?.slice?.(0, 15),
    )

    if (resData && data && parsedData !== invPacking?.[idx]?.[name]) {
      const updatedPacking = invPacking.map((item) => {
        if (item?.inventoryId === resData?.inventoryId) {
          if (name === 'amount') {
            return {
              ...item,
              amount: parsedData,
              totalPrice: (item.price || 0) * parsedData,
              isEdited: parsedData !== (item.originalAmount || item.amount),
            }
          } else if (name === 'price') {
            return {
              ...item,
              price: parsedData,
              totalPrice: parsedData * item.amount,
            }
          }
        }
        return item
      })

      if (JSON.stringify(updatedPacking) !== JSON.stringify(invPacking)) {
        dispatch(setInvPacking(updatedPacking))
      }
    } else if (data !== orders?.item?.[idx]?.[name] && !resData) {
      handleChange(name, data, idx)
    }
  }

  const handleLastPick = (e) => {
    const newListComodities = [...listComodities]

    const updatedOptions = newListComodities[0]?.options?.filter(
      (item) => item.id !== e.id,
    )

    updatedOptions.unshift(e)

    if (updatedOptions.length > 5) {
      const removedItem = updatedOptions.pop()

      newListComodities[1] = {
        ...newListComodities[1],
        options: [...newListComodities[1].options, removedItem],
      }
    }

    newListComodities[0] = {
      ...newListComodities[0],
      options: updatedOptions,
    }

    newListComodities[1] = {
      ...newListComodities[1],
      options: newListComodities[1].options.filter((item) => item.id !== e.id),
    }

    localStorage.setItem(
      'lastPickedCommoditiesSell',
      JSON.stringify(updatedOptions),
    )

    setListComodities(newListComodities)
  }

  const handleGetPack = async (collectedInventory, fieldNum, sourceGroup) => {
    try {
      if (
        !Array.isArray(collectedInventory) ||
        collectedInventory.length === 0
      ) {
        dispatch(setInvPacking([]))
        return
      }

      let targetFieldNum = fieldNum

      // Auto-merge: check if this commodity and unit already exists in another line item
      if (collectedInventory.length > 0) {
        const first = collectedInventory[0]
        const firstItemId = first?.itemId
        const firstUnit =
          first?.unit?.value || first?.unit || first?.item?.unit || ''

        const existingPack = invPacking?.find((p) => {
          const pUnit = p.unit?.value || p.unit || ''
          return (
            String(p.itemId) === String(firstItemId) &&
            String(pUnit).toLowerCase() === String(firstUnit).toLowerCase()
          )
        })

        if (
          existingPack &&
          Number(existingPack.fieldNum) !== Number(fieldNum)
        ) {
          targetFieldNum = existingPack.fieldNum
        }
      }

      const sourceGroupName =
        sourceGroup?.nameItem || sourceGroup?.label || sourceGroup?.name || null
      const sourceGroupId = sourceGroup?.id ?? sourceGroup?.value ?? null

      const newData = collectedInventory.map((e) => {
        const resolvedPackingId = e?.groupId ?? sourceGroupId ?? null
        const resolvedSourceGroupName =
          e?.sourceGroupName ||
          e?.groupName ||
          e?.group?.nameItem ||
          e?.group?.name ||
          sourceGroupName ||
          null

        // Use item nameItem directly from API data, not from listInventories
        const resolvedInventoryName =
          e?.item?.nameItem || e?.nameItem || e?.label || ''

        return {
          itemId: e?.itemId,
          SKU: e?.item?.SKU || e?.item?.sku || e?.SKU || e?.sku || '',
          amount: e?.amount ?? e?.item?.amount,
          originalAmount: e?.amount ?? e?.item?.amount,
          imageUrl: e?.item?.linkFoto,
          nameItem: resolvedInventoryName,
          unit: autoFetchPublicVersion?.unitArray.find((z) => {
            const zVal = String(z?.value || '').toLowerCase()
            const eVal = String(
              e?.unit?.value || e?.unit || e?.item?.unit || '',
            ).toLowerCase()
            return zVal === eVal
          }),
          inventoryId: e?.id,
          packingId: resolvedPackingId,
          sourceGroupName: resolvedSourceGroupName,
          fieldNum: targetFieldNum,
          lotCode:
            e?.lotCode ||
            e?.lot ||
            (e?.lots && e.lots.length > 0
              ? e.lots.reduce((latest, current) => {
                  if (!latest?.data?.createdAt) return current
                  return new Date(current.data.createdAt) >
                    new Date(latest.data.createdAt)
                    ? current
                    : latest
                }, e.lots[0])?.data?.lotCode
              : null),
          ownerCode: e?.ownerCode || null,
          projectId: e?.projectId ?? null,
          projectLabel: e?.projectLabel ?? null,
        }
      })

      dispatch(updateInvPacking(newData))

      // If we merged into an existing field, remove the current empty field
      if (Number(targetFieldNum) !== Number(fieldNum)) {
        dispatch(removeItem(fieldNum))
      }
    } catch (error) {
      console.error('Error in handleGetPack:', error)
    } finally {
      setLoading((prevState) => ({ ...prevState, inventory: false }))
    }
  }

  const collectInventoryRecursively = async (data) => {
    if (!data?.id) {
      throw new Error('Missing group ID.')
    }

    try {
      let collectedInventory = []

      const groupResponse = await dispatch(
        fetchInventoryGroups({ parentGroupId: data.id }),
      ).unwrap()

      if (groupResponse?.items?.length > 0) {
        for (const subGroup of groupResponse.items) {
          const subInventory = await collectInventoryRecursively(subGroup)
          collectedInventory.push(...subInventory)
        }
      }

      const inventoryResponse = await dispatch(
        getInventory({
          page: 0,
          size: 9999,
          groupId: data.id,
          isForTransaction: 1,
        }),
      ).unwrap()

      if (inventoryResponse?.items?.length > 0) {
        collectedInventory.push(...inventoryResponse.items)
      }
      return collectedInventory
    } catch (error) {
      console.error(`Error collecting inventory for groupId: ${data.id}`, error)
      return []
    }
  }

  const handleSelectInventoryItem = (
    e,
    index,
    currentFieldNum,
    { keepFieldGrouping = false } = {},
  ) => {
    const resolveInventoryName = (item) => {
      const matchingOption = (listInventories || [])
        .flatMap((group) => group?.options || [])
        .find(
          (opt) => String(opt?.id) === String(item?.id || item?.inventoryId),
        )

      return (
        matchingOption?.data?.item?.nameItem ||
        matchingOption?.data?.itemName ||
        matchingOption?.data?.nameItem ||
        item?.item?.nameItem ||
        item?.nameItem ||
        item?.label ||
        ''
      )
    }

    // Determine the relevant item properties
    const inventoryIdToSave = e?.id
    const matchedInventoryById = (inventories || []).find(
      (inv) => String(inv?.id) === String(inventoryIdToSave),
    )

    const resolvedNameItem = resolveInventoryName(matchedInventoryById || e)
    const resolvedSku =
      matchedInventoryById?.item?.SKU ||
      matchedInventoryById?.item?.sku ||
      e?.item?.SKU ||
      e?.item?.sku ||
      e?.SKU ||
      e?.sku ||
      ''
    const resolvedItemId = matchedInventoryById?.itemId || e?.itemId
    const resolvedImageUrl =
      matchedInventoryById?.item?.linkFoto ||
      e?.item?.linkFoto ||
      e?.imageUrl ||
      e?.img
    const resolvedUnit = autoFetchPublicVersion?.unitArray.find(
      (z) =>
        (z?.value ?? '').toLowerCase() ===
        (
          matchedInventoryById?.unit ??
          matchedInventoryById?.item?.unit ??
          e?.unit ??
          e?.item?.unit ??
          ''
        )
          .toString()
          .toLowerCase(),
    )

    const selectedAmount = e?.selectedAmount ?? e?.amount ?? e?.item?.amount
    const originalAmount = e?.originalAmount ?? e?.amount ?? e?.item?.amount

    const existingPack = keepFieldGrouping
      ? null
      : invPacking?.find((p) => {
          const itemUnit = p.unit?.value || p.unit || ''
          const targetUnit =
            resolvedUnit?.value ||
            resolvedUnit ||
            e?.unit?.value ||
            e?.unit ||
            ''
          return (
            String(p.itemId) === String(resolvedItemId) &&
            String(itemUnit).toLowerCase() === String(targetUnit).toLowerCase()
          )
        })
    if (existingPack) {
      const targetFieldNum = existingPack.fieldNum
      const newData = {
        itemId: resolvedItemId,
        SKU: resolvedSku,
        amount: selectedAmount,
        originalAmount: originalAmount,
        imageUrl: resolvedImageUrl,
        nameItem: resolvedNameItem,
        unit: resolvedUnit,
        inventoryId: inventoryIdToSave,
        packingId: null,
        fieldNum: targetFieldNum,
        komoditasUmum: e?.komoditasUmum,
        lotCode: e?.lotCode || e?.lot || null,
        ownerCode: e?.ownerCode || null,
        projectId: e?.projectId ?? null,
        projectLabel: e?.projectLabel ?? null,
      }

      if (!invPacking.some((p) => p.inventoryId === inventoryIdToSave)) {
        // Find all existing items for this fieldNum to append the new one
        const allFieldItems = invPacking.filter(
          (p) => Number(p.fieldNum) === Number(targetFieldNum),
        )
        dispatch(updateInvPacking([...allFieldItems, newData]))
      }

      if (targetFieldNum !== currentFieldNum) {
        dispatch(removeItem(currentFieldNum))
      }
    } else {
      const newData = {
        itemId: resolvedItemId,
        SKU: resolvedSku,
        amount: selectedAmount,
        originalAmount: originalAmount,
        imageUrl: resolvedImageUrl,
        nameItem: resolvedNameItem,
        unit: resolvedUnit,
        inventoryId: inventoryIdToSave,
        packingId: null,
        fieldNum: currentFieldNum,
        komoditasUmum: e?.komoditasUmum,
        lotCode: e?.lotCode || e?.lot || null,
        ownerCode: e?.ownerCode || null,
        projectId: e?.projectId ?? null,
        projectLabel: e?.projectLabel ?? null,
      }

      dispatch(updateInvPacking(newData))

      const itemName = resolvedNameItem
      const pseudoGroupInfo = {
        label: itemName,
        label2: itemName,
        nameItem: itemName,
        id: `pseudo-${e.itemId}`,
        itemId: e.itemId,
        isPacking: true,
      }
      handleChange('nameItem', pseudoGroupInfo, index, true, true)
    }
  }

  const getFilteredOptions = () => {
    const idsInv = orders?.item?.map((e) => String(e?.id)).filter(Boolean)
    const idsPack = invPacking?.map((e) => String(e?.packingId)).filter(Boolean)
    const idsSelectedInv = invPacking
      ?.map((e) => String(e?.inventoryId))
      .filter(Boolean)
    const selectedIds = [...idsInv, ...idsPack, ...idsSelectedInv]
    const transformedOptions = listInventories.map((group) => ({
      ...group,
      options: group.options.map((item) => ({
        ...item,
        isDisabled: selectedIds.includes(String(item.value)),
      })),
    }))

    return transformedOptions
  }

  useEffect(() => {
    if (isSplitting) {
      return
    }

    setListComodities(comodities)
    setListInventories([
      {
        label: 'GRUP INVENTORI',
        options: packings?.length
          ? packings.map((e) => ({
              label: e?.nameItem,
              ...e,
            }))
          : [],
      },
      {
        label: 'SEMUA INVENTORI',
        options: inventories?.length
          ? inventories.map((e) => ({
              label: e?.nameItem,
              ...e,
            }))
          : [],
      },
    ])
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comodities, inventories, packings, isSplitting])

  useEffect(() => {
    if (!isInventory || typeof setIsInventory !== 'function') return
    if (isInventory.length < addItemCount.length) {
      setIsInventory((prev) => {
        const diff = addItemCount.length - prev.length
        return [...prev, ...Array(diff).fill(false)]
      })
    } else if (isInventory.length > addItemCount.length) {
      setIsInventory((prev) => prev.slice(0, addItemCount.length))
    }
  }, [addItemCount.length, isInventory?.length, setIsInventory])

  // Auto-select komoditas when prefill data has nameItem but no selection yet
  useEffect(() => {
    const currentItem = orders?.item?.[idx]
    const processKey = [
      idx,
      currentItem?.nameItem ?? '',
      currentItem?.inventoryId ?? '',
      currentItem?.id ?? '',
      currentItem?.itemId ?? '',
      currentItem?.SKU ?? '',
      inventories?.length ?? 0,
      listInventories?.[1]?.options?.length ?? 0,
    ].join('|')

    // Only run auto-select if we haven't processed this exact item state
    if (processedNameItemRef.current === processKey) return

    // Skip only if a non-inventory row is already selected.
    if (
      currentItem?.id &&
      !(currentItem?.isFromManageStock && currentItem?.inventoryId)
    ) {
      setIsWaitingAutoInventory(false)
      return
    }

    // If item has inventoryId, search in inventories instead
    if (currentItem?.inventoryId) {
      setItemLoading?.(fieldNum, true)

      const isInventoriesReady = Array.isArray(inventories)

      // For inventory-origin flow, wait until SEMUA INVENTORI has loaded,
      // UNLESS we already have the pre-passed inventories from ManageStock.
      if (
        currentItem?.isFromManageStock &&
        !isInventoriesReady &&
        !currentItem?.itemDetail?.inventories
      ) {
        return
      }

      // Search for inventory by itemId or SKU (commodity), not inventoryId
      // because inventoryId can change after splits/merges
      const targetItemId = currentItem?.itemId || currentItem?.id
      const targetSKU = currentItem?.SKU

      if (currentItem?.isFromManageStock) {
        if (
          currentItem?.inventoryIds &&
          Array.isArray(currentItem.inventoryIds) &&
          currentItem.inventoryIds.length > 1
        ) {
          const inventoryIds = (currentItem.inventoryIds || []).map(String)
          const localMatched = (inventories || []).filter((opt) =>
            inventoryIds.includes(String(opt.id)),
          )

          const prePassed = currentItem?.itemDetail?.inventories || []

          // Combine both sources, avoiding duplicates by ID.
          // This ensures that even if an item is not in the local filtered list (because it's in a group),
          // it is still included if it was pre-passed from ManageStock.
          const matchedInventories = [...localMatched]
          prePassed.forEach((preInv) => {
            if (
              !matchedInventories.some(
                (inv) => String(inv.id) === String(preInv.id),
              )
            ) {
              matchedInventories.push(preInv)
            }
          })

          if (matchedInventories.length > 0) {
            processedNameItemRef.current = processKey
            setIsInventory((prev) => {
              const updated = [...prev]
              updated[idx] = true
              return updated
            })

            void (async () => {
              setLoading((prevState) => ({ ...prevState, inventory: true }))
              try {
                await handleGetPack(matchedInventories, fieldNum, null)
                const first = matchedInventories[0]
                const resolvedNameItem =
                  first?.item?.nameItem ||
                  first?.nameItem ||
                  currentItem?.nameItem ||
                  ''
                const pseudoGroupInfo = {
                  label: resolvedNameItem,
                  label2: resolvedNameItem,
                  nameItem: resolvedNameItem,
                  id: `pseudo-${first?.itemId || currentItem?.itemId}`,
                  itemId: first?.itemId || currentItem?.itemId,
                  isPacking: true,
                  sourceGroupName:
                    first?.sourceGroupName ||
                    first?.group?.nameItem ||
                    first?.group?.name,
                }
                handleChange('nameItem', pseudoGroupInfo, idx, true, true)
              } finally {
                setItemLoading?.(fieldNum, false)
                setLoading((prevState) => ({ ...prevState, inventory: false }))
              }
            })()
            return
          }
        }

        let matchedInventory = (inventories || []).find(
          (opt) => String(opt.id) === String(currentItem.inventoryId),
        )

        if (!matchedInventory && currentItem?.itemDetail?.inventories?.[0]) {
          matchedInventory = currentItem.itemDetail.inventories[0]
        }

        const canFallbackByCommodity =
          !currentItem?.inventoryId && !currentItem?.itemDetail?.inventoryId

        const matchedByCommodity =
          !matchedInventory && canFallbackByCommodity
            ? (inventories || []).find((opt) => {
                if (
                  currentItem?.itemId &&
                  String(opt?.itemId) === String(currentItem.itemId)
                ) {
                  return true
                }

                const optSku = opt?.item?.SKU || opt?.SKU || opt?.sku
                return (
                  currentItem?.SKU &&
                  optSku &&
                  String(optSku) === String(currentItem.SKU)
                )
              })
            : null

        const resolvedInventory = matchedInventory || matchedByCommodity
        const resolvedNameItem =
          resolvedInventory?.item?.nameItem || resolvedInventory?.nameItem || ''
        const groupIdCandidate =
          currentItem?.groupId || currentItem?.itemDetail?.groupId || null

        if (
          !resolvedInventory &&
          groupIdCandidate &&
          currentItem?.inventoryId
        ) {
          processedNameItemRef.current = processKey
          setIsWaitingAutoInventory(true)

          const resolvedGroupOption = listInventories?.[0]?.options?.find(
            (opt) => String(opt?.id) === String(groupIdCandidate),
          ) || {
            id: groupIdCandidate,
            nameItem:
              currentItem?.groupName ||
              currentItem?.itemDetail?.groupName ||
              `Grup ${groupIdCandidate}`,
          }

          // Open modal immediately so users see a loading state while group items load.
          setPendingGroupSelection(resolvedGroupOption)
          setInitialGroupSelectedItemIds([])
          setGroupItems([])
          setIsLoadingGroupItems(true)
          setShowGroupPickerModal(true)

          void (async () => {
            try {
              const groupedInventoryResponse = await dispatch(
                getInventory({
                  page: 0,
                  size: 9999,
                  groupId: groupIdCandidate,
                  isForTransaction: 1,
                }),
              ).unwrap()

              const groupedItems = groupedInventoryResponse?.items || []
              const groupedMatch = groupedItems.find(
                (opt) => String(opt?.id) === String(currentItem.inventoryId),
              )

              if (groupedMatch) {
                setPendingGroupSelection(resolvedGroupOption)
                setGroupItems(groupedItems)
                setInitialGroupSelectedItemIds([groupedMatch.id])
                setShowGroupPickerModal(true)
                setIsLoadingGroupItems(false)
                setIsWaitingAutoInventory(false)
                setItemLoading?.(fieldNum, false)
                return
              }

              setShowGroupPickerModal(false)
              setPendingGroupSelection(null)
              setGroupItems([])
              setInitialGroupSelectedItemIds([])
              setIsLoadingGroupItems(false)
            } catch (error) {
              console.warn('Failed to resolve grouped inventory for scanner', {
                groupId: groupIdCandidate,
                inventoryId: currentItem?.inventoryId,
                error,
              })
              setShowGroupPickerModal(false)
              setPendingGroupSelection(null)
              setGroupItems([])
              setInitialGroupSelectedItemIds([])
              setIsLoadingGroupItems(false)
            }

            const fallbackInventory = {
              id: currentItem.inventoryId,
              itemId: currentItem.itemId,
              SKU: currentItem.SKU,
              sku: currentItem.SKU,
              amount: currentItem.amount,
              selectedAmount: currentItem.amount,
              originalAmount: currentItem.originalAmount ?? currentItem.amount,
              imageUrl: currentItem.imageUrl,
              img: currentItem.imageUrl,
              nameItem: resolvedNameItem || currentItem?.nameItem || '',
              label: resolvedNameItem || currentItem?.nameItem || '',
              unit: currentItem?.unit?.value || currentItem?.unit,
              item: {
                SKU: currentItem.SKU,
                unit: currentItem?.unit?.value || currentItem?.unit,
                nameItem: resolvedNameItem || currentItem?.nameItem || '',
                linkFoto: currentItem.imageUrl,
              },
            }

            handleSelectInventoryItem(fallbackInventory, idx, fieldNum, {
              keepFieldGrouping: true,
            })
            setIsWaitingAutoInventory(false)
            setItemLoading?.(fieldNum, false)
          })()

          return
        }

        const hasScannedAmount =
          currentItem?.amount !== null &&
          currentItem?.amount !== undefined &&
          String(currentItem?.amount).trim() !== ''
        const resolvedInventoryWithSelectedAmount = resolvedInventory
          ? {
              ...resolvedInventory,
              ...(hasScannedAmount
                ? {
                    selectedAmount: currentItem.amount,
                    originalAmount:
                      resolvedInventory?.amount ??
                      resolvedInventory?.item?.amount ??
                      currentItem?.originalAmount ??
                      currentItem?.amount,
                  }
                : {}),
            }
          : null

        const fallbackInventory = {
          id: currentItem.inventoryId,
          itemId: currentItem.itemId,
          SKU: currentItem.SKU,
          sku: currentItem.SKU,
          amount: currentItem.amount,
          selectedAmount: currentItem.amount,
          originalAmount: currentItem.originalAmount ?? currentItem.amount,
          imageUrl: currentItem.imageUrl,
          img: currentItem.imageUrl,
          nameItem: resolvedNameItem || currentItem?.nameItem || '',
          label: resolvedNameItem || currentItem?.nameItem || '',
          unit: currentItem?.unit?.value || currentItem?.unit,
          item: {
            SKU: currentItem.SKU,
            unit: currentItem?.unit?.value || currentItem?.unit,
            nameItem: resolvedNameItem || currentItem?.nameItem || '',
            linkFoto: currentItem.imageUrl,
          },
        }

        if (resolvedInventory) {
          processedNameItemRef.current = processKey
          setIsWaitingAutoInventory(false)

          setIsInventory((prev) => {
            const updated = [...prev]
            updated[idx] = true
            return updated
          })

          // Keep inventory-origin flow using grouped inventory card layout.
          handleSelectInventoryItem(
            resolvedInventoryWithSelectedAmount,
            idx,
            fieldNum,
            {
              keepFieldGrouping: true,
            },
          )

          setItemLoading?.(fieldNum, false)

          return
        }

        processedNameItemRef.current = processKey
        setIsWaitingAutoInventory(false)

        // Keep card list stable even when inventory cache lookup misses.
        handleSelectInventoryItem(fallbackInventory, idx, fieldNum, {
          keepFieldGrouping: true,
        })

        setIsWaitingAutoInventory(false)
        console.warn(
          `No inventory found for itemId ${targetItemId} or SKU ${targetSKU}`,
        )
        setItemLoading?.(fieldNum, false)

        return
      }

      let matchedInventories = []
      for (const group of listInventories) {
        if (!group.options) continue

        const found = group.options.filter((opt) => {
          // Match by itemId (commodity type)
          if (
            targetItemId &&
            (String(opt.itemId) === String(targetItemId) ||
              String(opt.item?.id) === String(targetItemId))
          ) {
            return true
          }
          // Match by SKU as fallback
          if (targetSKU && opt.SKU === targetSKU) {
            return true
          }
          if (targetSKU && opt.sku === targetSKU) {
            return true
          }
          if (targetSKU && opt.item?.SKU === targetSKU) {
            return true
          }
          return false
        })

        if (found.length > 0) {
          matchedInventories.push(...found)
        }
      }

      // If found inventories, select the one with largest amount
      if (matchedInventories.length > 0) {
        // Sort by amount descending and pick the largest
        matchedInventories.sort((a, b) => {
          const aAmount = parseFloat(a.amount || 0)
          const bAmount = parseFloat(b.amount || 0)
          return bAmount - aAmount
        })

        const matchedInventory = matchedInventories[0]

        processedNameItemRef.current = processKey
        setIsWaitingAutoInventory(false)

        setIsInventory((prev) => {
          const updated = [...prev]
          updated[idx] = true
          return updated
        })

        // Use the new grouping mechanism to automatically merge
        handleSelectInventoryItem(matchedInventory, idx, fieldNum)
        setItemLoading?.(fieldNum, false)

        return
      }

      if (isLoading) {
        return
      }

      setIsWaitingAutoInventory(false)
      processedNameItemRef.current = processKey
      console.warn(
        `No inventory found for itemId ${targetItemId} or SKU ${targetSKU}`,
      )
      setItemLoading?.(fieldNum, false)

      return
    }

    setIsWaitingAutoInventory(false)

    // Commodity flow still needs a readable name to auto-select.
    if (!currentItem?.nameItem) {
      return
    }

    // Skip if listComodities not ready
    if (!listComodities?.length) {
      return
    }

    // Try to find matching komoditas in listComodities
    let matchedOption = null

    // Search in all commodity groups
    for (const group of listComodities) {
      if (!group.options) continue

      matchedOption = group.options.find((opt) => {
        const optName =
          opt.label?.toLowerCase() || opt.nameItem?.toLowerCase() || ''
        if (typeof currentItem.nameItem !== 'string') {
          console.error(
            'currentItem.nameItem is not a string!',
            currentItem.nameItem,
            typeof currentItem.nameItem,
          )
        }
        const currentName =
          typeof currentItem.nameItem === 'string'
            ? currentItem.nameItem.toLowerCase()
            : ''
        return optName === currentName
      })
      if (matchedOption) break
    }
    // If found a match, auto-select it
    if (matchedOption && !isInventory?.[idx]) {
      handleChange('nameItem', matchedOption, idx)
      handleLastPick(matchedOption)
    }

    processedNameItemRef.current = processKey
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    listComodities,
    listInventories,
    inventories,
    isLoading,
    idx,
    fieldNum,
    orders?.item?.[idx]?.nameItem,
    orders?.item?.[idx]?.id,
    orders?.item?.[idx]?.inventoryId,
    orders?.item?.[idx]?.itemId,
    orders?.item?.[idx]?.SKU,
    orders?.item?.[idx]?.isFromManageStock,
  ])

  const isFirstItemOfGroup = (data, currentIndex, currentItemId) => {
    return data?.findIndex((d) => d?.itemId === currentItemId) === currentIndex
  }

  const handleSetPricePerSatuan = (itemId, sourcePrice) => {
    if (!itemId) return

    let priceToUse = sourcePrice

    if (priceToUse === undefined) {
      const sourceItem = invPacking?.find(
        (item) => item?.itemId === itemId && Number(item?.price) > 0,
      )
      if (!sourceItem) {
        return
      }
      priceToUse = sourceItem.price
    }

    if (!priceToUse || Number(priceToUse) === 0) return

    const updatedPacking = invPacking?.map((item) => {
      if (item?.itemId === itemId) {
        const numericAmount =
          typeof item.amount === 'string'
            ? Number(
                item.amount
                  ?.replace(/\./g, '')
                  ?.replace(/\,/g, '.')
                  ?.slice(0, 15),
              )
            : item.amount

        return {
          ...item,
          price: priceToUse,
          totalPrice: priceToUse * numericAmount,
        }
      }
      return item
    })

    dispatch(setInvPacking(updatedPacking))

    const newPriceVersions = { ...priceVersions }
    updatedPacking.forEach((item) => {
      if (item.itemId === itemId) {
        newPriceVersions[item.inventoryId] =
          (newPriceVersions[item.inventoryId] || 0) + 1
      }
    })

    setPriceVersions(newPriceVersions)
  }

  const handleSetPricePerSatuanUmum = (currentId, sourcePrice) => {
    if (!currentId) return

    let priceToUse = sourcePrice
    if (priceToUse === undefined) {
      const sourceItem = orders?.item?.find(
        (item, idx) =>
          item?.id === currentId &&
          isInventory?.[idx] === false &&
          Number(item?.price) > 0,
      )
      if (!sourceItem) return
      priceToUse = sourceItem.price
    }

    if (!priceToUse || Number(priceToUse) === 0) return

    const parsedPrice =
      typeof priceToUse === 'string'
        ? Number(
            priceToUse?.replace(/\./g, '')?.replace(/\,/g, '.')?.slice(0, 15),
          )
        : Number(priceToUse)

    const newData = orders.item.map((item, index) => {
      if (item?.id === currentId && isInventory?.[index] === false) {
        const amount =
          typeof item.amount === 'string'
            ? Number(
                item.amount
                  ?.replace(/\./g, '')
                  ?.replace(/\,/g, '.')
                  ?.slice(0, 15),
              ) || 0
            : Number(item.amount) || 0

        return {
          ...item,
          price: parsedPrice,
          totalPrice: parsedPrice * amount,
        }
      }
      return item
    })

    if (JSON.stringify(newData) !== JSON.stringify(orders.item)) {
      dispatch(setOrdersPayload(newData))

      const newPriceVersions = { ...priceVersions }
      newData.forEach((item, index) => {
        if (item?.id === currentId && isInventory?.[index] === false) {
          newPriceVersions[`umum-${index}`] =
            (newPriceVersions[`umum-${index}`] || 0) + 1
        }
      })
      setPriceVersions(newPriceVersions)
    }
  }

  const handleApplyPriceAndUnit = (price, unit, targetIdx, resData) => {
    if (resData) {
      handleChangeInputSeparator(String(price), 'price', targetIdx, resData)
      return
    }

    const priceString = String(price)
    const unitObj = unit
      ? { label: unit, value: String(unit).toLowerCase() }
      : orders?.item?.[targetIdx]?.unit

    const updatedItems = orders.item.map((item, i) => {
      if (i === targetIdx) {
        const amountRaw = item?.amount
        const amountNum =
          typeof amountRaw === 'string'
            ? Number(
                amountRaw
                  ?.replace(/\./g, '')
                  ?.replace(/\,/g, '.')
                  ?.slice(0, 15),
              ) || 0
            : Number(amountRaw) || 0

        const priceNum =
          typeof priceString === 'string'
            ? Number(
                priceString
                  ?.replace(/\./g, '')
                  ?.replace(/\,/g, '.')
                  ?.slice(0, 15),
              ) || 0
            : Number(priceString) || 0

        return {
          ...item,
          price: priceString,
          ...(unitObj && { unit: unitObj }),
          totalPrice: priceNum * amountNum,
        }
      }
      return item
    })

    dispatch(setOrdersPayload(updatedItems))

    setPriceVersions((prev) => ({
      ...prev,
      [`umum-${targetIdx}`]: (prev[`umum-${targetIdx}`] || 0) + 1,
      [targetIdx]: (prev[targetIdx] || 0) + 1,
    }))
  }

  // Apply price to all non-packing items with same base commodity and unit
  const handleSetPriceForAllItems = () => {
    const currentItem = orders?.item?.[idx]
    if (!currentItem?.price) return

    const priceToUse = currentItem.price
    const currentUnit = currentItem?.unit?.value
    const currentBaseId = currentItem?.itemId || currentItem?.id

    if (!currentBaseId) return

    const updatedItems = orders.item.map((item, i) => {
      const itemBaseId = item?.itemId || item?.id
      if (
        i !== idx &&
        itemBaseId &&
        String(itemBaseId) === String(currentBaseId) &&
        item?.unit?.value === currentUnit &&
        !item?.isPacking
      ) {
        const numericAmount = parseNumber(item.amount)
        const numericPrice = parseNumber(priceToUse)
        return {
          ...item,
          price: priceToUse,
          totalPrice: numericPrice * numericAmount,
        }
      }
      return item
    })

    dispatch(setOrdersPayload(updatedItems))
  }

  const handleRemoveSpecificInventories = (
    inventoryIds = [],
    targetFieldNum = fieldNum,
  ) => {
    const idsToRemove = (Array.isArray(inventoryIds) ? inventoryIds : [])
      .filter((id) => id !== undefined && id !== null)
      .map((id) => String(id))

    if (idsToRemove.length === 0) {
      if (targetFieldNum !== 1 || addItemCount.length > 1) {
        dispatch(removeItem(targetFieldNum))
      } else {
        dispatch(removePacking(targetFieldNum))
        dispatch(
          resetItemToDefault({
            type: 'inventori_anda',
            fieldNum: targetFieldNum,
          }),
        )
      }
      return
    }

    const updatedPack = (invPacking || []).filter(
      (item) => !idsToRemove.includes(String(item?.inventoryId)),
    )

    const hasRemainingInField = updatedPack.some(
      (item) => Number(item?.fieldNum) === Number(targetFieldNum),
    )

    if (hasRemainingInField) {
      dispatch(setInvPacking(updatedPack))
      return
    }

    if (targetFieldNum !== 1 || addItemCount.length > 1) {
      dispatch(removeItem(targetFieldNum))
    } else {
      dispatch(removePacking(targetFieldNum))
      dispatch(
        resetItemToDefault({
          type: 'inventori_anda',
          fieldNum: targetFieldNum,
        }),
      )
    }
  }

  const handleRemoveKomoditasUmum = (targetFieldNum, indices = []) => {
    if (targetFieldNum !== 1 || addItemCount.length > 1) {
      if (indices && indices.length > 0) {
        indices.reverse().forEach((mIdx) => {
          const fNum = addItemCount[mIdx]
          if (fNum) dispatch(removeItem(fNum))
        })
      } else if (targetFieldNum) {
        dispatch(removeItem(targetFieldNum))
      }
    } else {
      const fNum = targetFieldNum || fieldNum
      dispatch(
        resetItemToDefault({
          type: 'komoditas_umum',
          fieldNum: fNum,
        }),
      )
      setIsInventory((prev) => {
        const updated = [...prev]
        if (idx < updated.length) {
          updated[idx] = false
        }
        return updated
      })
    }
  }

  const handleOpenSplitModal = (splitSourceItem = null) => {
    if (
      splitSourceItem &&
      (splitSourceItem?.inventoryId || splitSourceItem?.id)
    ) {
      setSelectedItemForSplit({
        ...splitSourceItem,
        id: splitSourceItem?.inventoryId || splitSourceItem?.id,
        inventoryId: splitSourceItem?.inventoryId || splitSourceItem?.id,
      })
      setSplitTargetContext({
        mode: 'invPacking',
        sourceInventoryId: splitSourceItem?.inventoryId || splitSourceItem?.id,
        sourceFieldNum: splitSourceItem?.fieldNum || fieldNum,
      })
      setModalSplitOpen(true)
      return
    }

    const currentItem = orders?.item?.[idx]
    if (currentItem && currentItem.inventoryId) {
      setSelectedItemForSplit(currentItem)
      setSplitTargetContext({
        mode: 'order',
      })
      setModalSplitOpen(true)
    }
  }

  const handleCloseSplitModal = () => {
    setModalSplitOpen(false)
    setSelectedItemForSplit(null)
    setSplitTargetContext(null)
  }

  const handleSplitSuccess = async (splitResult) => {
    if (
      !splitResult ||
      !Array.isArray(splitResult) ||
      splitResult.length === 0
    ) {
      return
    }

    try {
      setIsSplitting(true)

      // REFRESH INVENATORIES
      await new Promise((resolve) => setTimeout(resolve, 300))
      const updatedInventories = await dispatch(getInventories()).unwrap()

      // UPDATE LIST INVENATORIES
      const newListInventories = [
        {
          label: 'GRUP INVENTORI',
          options: packings?.length
            ? packings.map((e) => ({ label: e?.nameItem, value: e?.id, ...e }))
            : [],
        },
        {
          label: 'SEMUA INVENTORI',
          options: updatedInventories?.length
            ? updatedInventories.map((e) => ({
                label: e?.nameItem,
                value: e?.id,
                ...e,
              }))
            : [],
        },
      ]

      setListInventories(newListInventories)
      await new Promise((resolve) => setTimeout(resolve, 400))

      // Revamped grouped inventory flow keeps inventory rows in invPacking.
      if (splitTargetContext?.mode === 'invPacking') {
        const sourceInventoryId = String(splitTargetContext?.sourceInventoryId)
        const sourceItem = (invPacking || []).find(
          (item) => String(item?.inventoryId) === sourceInventoryId,
        )
        const fallbackSource = sourceItem || selectedItemForSplit || {}

        const targetFieldNum =
          sourceItem?.fieldNum || splitTargetContext?.sourceFieldNum || fieldNum

        const mappedSplitItems = splitResult
          .map((splitItem) => {
            const matchedInventory = (updatedInventories || []).find(
              (inv) => String(inv?.id) === String(splitItem?.id),
            )

            const amount = Number(
              matchedInventory?.amount ?? splitItem?.amount ?? 0,
            )
            const resolvedUnitRaw =
              matchedInventory?.unit ||
              matchedInventory?.item?.unit ||
              fallbackSource?.unit?.value ||
              fallbackSource?.unit ||
              ''

            const resolvedUnit =
              autoFetchPublicVersion?.unitArray?.find(
                (u) =>
                  (u?.value ?? '').toLowerCase() ===
                  String(resolvedUnitRaw).toLowerCase(),
              ) || fallbackSource?.unit

            if (!(matchedInventory?.id || splitItem?.id)) {
              return null
            }

            const parsedPrice = Number(fallbackSource?.price)
            const safePrice = Number.isFinite(parsedPrice) ? parsedPrice : null

            return {
              itemId:
                matchedInventory?.itemId ||
                matchedInventory?.item?.id ||
                splitItem?.itemId ||
                fallbackSource?.itemId,
              SKU:
                matchedInventory?.item?.SKU ||
                matchedInventory?.SKU ||
                matchedInventory?.sku ||
                fallbackSource?.SKU ||
                '',
              amount,
              originalAmount: amount,
              imageUrl:
                matchedInventory?.item?.linkFoto ||
                matchedInventory?.imageUrl ||
                fallbackSource?.imageUrl,
              nameItem:
                matchedInventory?.item?.nameItem ||
                matchedInventory?.nameItem ||
                fallbackSource?.nameItem,
              unit: resolvedUnit,
              inventoryId: matchedInventory?.id || splitItem?.id,
              packingId: fallbackSource?.packingId ?? null,
              sourceGroupName: fallbackSource?.sourceGroupName ?? null,
              fieldNum: targetFieldNum,
              lotCode:
                matchedInventory?.lotCode ||
                splitItem?.lotCode ||
                fallbackSource?.lotCode,
              ownerCode:
                matchedInventory?.ownerCode ||
                splitItem?.ownerCode ||
                fallbackSource?.ownerCode,
              ...(safePrice !== null
                ? {
                    price: safePrice,
                    totalPrice: safePrice * amount,
                  }
                : {}),
            }
          })
          .filter(Boolean)

        if (mappedSplitItems.length > 0) {
          const updatedPacking = (invPacking || [])
            .filter((item) => String(item?.inventoryId) !== sourceInventoryId)
            .concat(mappedSplitItems)
            .sort((a, b) => (a.itemId ?? 0) - (b.itemId ?? 0))

          dispatch(setInvPacking(updatedPacking))
        }

        setIsSplitting(false)
        return
      }

      // COLLECT INVENTORIES TO SELECT
      const inventoriesToSelect = []
      for (let i = 0; i < splitResult.length; i++) {
        const splitInventory = splitResult[i]
        const inventoryData = updatedInventories?.find(
          (inv) => inv.id === splitInventory.id,
        )

        if (inventoryData) {
          inventoriesToSelect.push({
            ...inventoryData,
            label: inventoryData.nameItem,
            label2: inventoryData.nameItem,
            isPacking: false,
            amount: inventoryData.amount,
          })
        }
      }

      if (inventoriesToSelect.length === 0) {
        setIsSplitting(false)
        return
      }

      // LOCK WITH NEW ORDERS DATA
      const currentOrders = [...orders.item]
      const currentOrdersLength = currentOrders.length

      currentOrders[idx] = {
        ...currentOrders[idx],
        nameItem:
          inventoriesToSelect[0].nameItem || inventoriesToSelect[0].label2,
        id: inventoriesToSelect[0].id,
        SKU: inventoriesToSelect[0].sku || '',
        imageUrl: inventoriesToSelect[0].img || '',
        isPacking: false,
        inventoryId: inventoriesToSelect[0].id,
        itemId: inventoriesToSelect[0].itemId,
        lotCode: inventoriesToSelect[0].lotCode,
        ownerCode: inventoriesToSelect[0].ownerCode,
        originalAmount: inventoriesToSelect[0].amount,
        amount: intl
          .formatNumber(inventoriesToSelect[0].amount, {
            useGrouping: 'always',
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })
          .toString(),
        unit: autoFetchPublicVersion?.unitArray.find(
          (z) =>
            (z?.value ?? '').toLowerCase() ===
            (inventoriesToSelect[0]?.unit ?? '').toLowerCase(),
        ),
        price: '',
        totalPrice: 0,
      }

      const currentAddItemCount = [...addItemCount]

      for (let i = 1; i < inventoriesToSelect.length; i++) {
        const inventory = inventoriesToSelect[i]
        const newOrderId =
          currentAddItemCount[currentAddItemCount.length - 1] + 1

        currentOrders.push({
          orderItemId: newOrderId,
          nameItem: inventory.nameItem || inventory.label2,
          id: inventory.id,
          SKU: inventory.sku || '',
          imageUrl: inventory.img || '',
          isPacking: false,
          inventoryId: inventory.id,
          itemId: inventory.itemId,
          lotCode: inventory.lotCode,
          ownerCode: inventory.ownerCode,
          originalAmount: inventory.amount,
          amount: intl
            .formatNumber(inventory.amount, {
              useGrouping: 'always',
              minimumFractionDigits: 0,
              maximumFractionDigits: 2,
            })
            .toString(),
          unit: autoFetchPublicVersion?.unitArray.find(
            (z) =>
              (z?.value ?? '').toLowerCase() ===
              (inventory?.unit ?? '').toLowerCase(),
          ),
          price: '',
          totalPrice: 0,
        })

        currentAddItemCount.push(newOrderId)
      }

      setIsInventory((prev) => {
        const updated = [...prev]
        updated[idx] = true
        for (let i = 1; i < inventoriesToSelect.length; i++) {
          updated[currentOrdersLength + (i - 1)] = true
        }
        return updated
      })

      dispatch(setOrdersPayload(currentOrders))
      dispatch(setItemCount(currentAddItemCount))
      await new Promise((resolve) => setTimeout(resolve, 800))
      setIsSplitting(false)
    } catch (error) {
      setIsSplitting(false)
    }
  }

  useEffect(() => {
    if (invToTrx) {
      dispatch(
        resetItemToDefault({
          type: 'inventori_anda',
          fieldNum,
        }),
      )
      setIsInventory((prev) => {
        const updated = [...prev]
        updated[idx] = true
        return updated
      })
    }
  }, [])

  // Helper for parsing numbers (Indonesian format)
  const parseNumber = (val) => {
    if (val === undefined || val === null) return 0
    if (typeof val === 'number') return val
    try {
      return (
        Number(
          val?.replace?.(/\./g, '')?.replace?.(/\,/g, '.')?.slice?.(0, 15),
        ) || 0
      )
    } catch (e) {
      return 0
    }
  }

  const resolveSourceGroupName = (item) => {
    if (!item) return ''

    if (item?.sourceGroupName) {
      return item.sourceGroupName
    }

    if (currentItem?.sourceGroupName) {
      return currentItem.sourceGroupName
    }

    if (item?.groupName) {
      return item.groupName
    }

    if (item?.group?.nameItem || item?.group?.name || item?.group?.label) {
      return item.group?.nameItem || item.group?.name || item.group?.label
    }

    const packingId = item?.packingId ?? item?.groupId
    if (!packingId || !Array.isArray(packings)) {
      return ''
    }

    const matchedGroup = packings.find(
      (pack) => Number(pack?.id ?? pack?.value) === Number(packingId),
    )

    return matchedGroup?.nameItem || matchedGroup?.label || ''
  }

  // Handle auto-pick result from modal
  // After split/merge is done in ModalAutoPick, this just populates the order items
  // using the same data structure as normal inventory selection
  const handleAutoPickApply = async ({ finalRows, parseNumber: parse }) => {
    const currentOrders = [...orders.item]
    const currentAddItemCount = [...addItemCount]

    if (finalRows.length > 0) {
      // Find unit from unitArray (same as handleChange does for inventory)
      const findUnit = (unitValue) => {
        const unitStr =
          typeof unitValue === 'string'
            ? unitValue
            : unitValue?.value || unitValue?.label || 'Kg'
        return (
          autoFetchPublicVersion?.unitArray?.find(
            (z) => (z?.value ?? '').toLowerCase() === unitStr.toLowerCase(),
          ) || { value: unitStr, label: unitStr }
        )
      }

      // Use same structure as handleChange for inventory selection
      // Get imageUrl - inventory uses 'img' field from item.linkFoto
      const getImageUrl = (row) =>
        row.img || row.imageUrl || row?.item?.linkFoto || ''

      const currentOrderId = orders.item[idx]?.orderItemId || currentAddItemCount[idx]

      const isGrouped = finalRows.length > 1
      const totalAmount = finalRows.reduce((sum, r) => sum + (Number(r.amount) || 0), 0)
      const firstRow = finalRows[0]

      const formattedFirstAmount = intl
        .formatNumber(firstRow.amount, {
          useGrouping: 'always',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
        .toString()

      const formattedTotalAmount = intl
        .formatNumber(totalAmount, {
          useGrouping: 'always',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2,
        })
        .toString()

      const newOrderItem = {
        ...currentOrders[idx],
        orderItemId: currentOrderId,
        nameItem: firstRow.nameItem || firstRow.label2 || currentOrders[idx]?.nameItem,
        id: isGrouped ? `pseudo-${firstRow.itemId || currentOrders[idx]?.itemId}` : (firstRow.inventoryId || firstRow.id),
        SKU: isGrouped ? '' : (firstRow.SKU ?? firstRow.sku ?? firstRow?.item?.SKU ?? ''),
        imageUrl: getImageUrl(firstRow),
        isPacking: isGrouped,
        inventoryId: isGrouped ? undefined : (firstRow.inventoryId || firstRow.id),
        itemId: firstRow.itemId || currentOrders[idx]?.itemId,
        originalAmount: isGrouped ? totalAmount : firstRow.amount,
        amount: isGrouped ? formattedTotalAmount : formattedFirstAmount,
        unit: findUnit(firstRow.unit),
        price: currentOrders[idx]?.price ?? '',
        totalPrice: currentOrders[idx]?.totalPrice ?? 0,
        lotCode: isGrouped ? null : (firstRow.lotCode || firstRow.lot || null),
        ownerCode: isGrouped ? null : (firstRow.ownerCode || null),
      }

      const allNewPackings = []
      if (isGrouped) {
        finalRows.forEach((it) => {
          allNewPackings.push({
            itemId: it?.itemId || currentOrders[idx]?.itemId,
            SKU: it?.SKU || '',
            amount:
              typeof it?.amount === 'string'
                ? Number(
                    it?.amount
                      ?.replace(/\./g, '')
                      ?.replace(/\,/g, '.')
                      ?.slice(0, 15),
                  ) || 0
                : Number(it?.amount) || 0,
            originalAmount:
              typeof it?.amount === 'string'
                ? Number(
                    it?.amount
                      ?.replace(/\./g, '')
                      ?.replace(/\,/g, '.')
                      ?.slice(0, 15),
                  ) || 0
                : Number(it?.amount) || 0,
            imageUrl: getImageUrl(it),
            nameItem: it?.nameItem || it?.label2 || newOrderItem.nameItem,
            unit: findUnit(it?.unit),
            inventoryId: it?.inventoryId || it?.id,
            packingId: null,
            fieldNum: currentOrderId,
            lotCode: it?.lotCode || it?.lot || null,
            ownerCode: it?.ownerCode || null,
          })
        })
      }

      // Replace original item at idx with the single newOrderItem
      currentOrders[idx] = newOrderItem

      // Update state
      setIsInventory((prev) => {
        const updated = [...prev]
        updated[currentOrderId - 1] = true
        return updated
      })

      dispatch(setOrdersPayload(currentOrders))
      dispatch(setItemCount(currentAddItemCount))

      // Process invPacking from finalRows
      const currentPacking = [...(invPacking || [])]
      // Remove old packing items for this fieldNum
      const filteredPacking = currentPacking.filter(
        (p) => p.fieldNum !== currentOrderId
      )

      dispatch(setInvPacking([...filteredPacking, ...allNewPackings]))
    }

    // Refresh inventory list after split/merge operations
    try {
      const updatedInventories = await dispatch(getInventories()).unwrap()
      const newListInventories = [
        {
          label: 'GRUP INVENTORI',
          options: packings?.length
            ? packings.map((e) => ({ label: e?.nameItem, value: e?.id, ...e }))
            : [],
        },
        {
          label: 'SEMUA INVENTORI',
          options: updatedInventories?.length
            ? updatedInventories.map((e) => ({
                label: e?.nameItem,
                value: e?.id,
                ...e,
              }))
            : [],
        },
      ]
      setListInventories(newListInventories)
    } catch (error) {
      console.error('Error refreshing inventories after apply:', error)
    }
  }

  const currentItem = orders?.item?.[idx] ?? {}

  useEffect(() => {
    const currentPacking = invPacking || []
    const inventoryOriginRows = (orders?.item || []).filter(
      (it) =>
        (it?.isFromManageStock || it?.itemDetail?.inventoryId) &&
        !!it?.inventoryId &&
        !!it?.orderItemId,
    )

    if (!inventoryOriginRows.length) return

    const missingRows = inventoryOriginRows.filter(
      (it) =>
        !currentPacking.some(
          (p) => Number(p?.fieldNum) === Number(it?.orderItemId),
        ),
    )

    if (!missingRows.length) return

    const parseAmount = (value) => {
      if (typeof value === 'number') return value
      if (typeof value === 'string') {
        return (
          Number(
            value?.replace(/\./g, '')?.replace(/\,/g, '.')?.slice(0, 15),
          ) || 0
        )
      }
      return 0
    }

    const backfilledPacking = []
    missingRows.forEach((it) => {
      // Explode aggregated rows if they contain individual inventories (e.g. from Manage Stock)
      const subItems = it?.itemDetail?.inventories || [it]
      subItems.forEach((sub) => {
        backfilledPacking.push({
          itemId: sub?.itemId || it?.itemId,
          SKU: sub?.SKU || sub?.item?.SKU || it?.SKU || '',
          amount: parseAmount(sub?.amount ?? sub?.item?.amount ?? it?.amount),
          originalAmount: parseAmount(
            sub?.originalAmount ??
              sub?.amount ??
              sub?.item?.amount ??
              it?.amount,
          ),
          imageUrl: sub?.item?.linkFoto || sub?.imageUrl || it?.imageUrl,
          nameItem: sub?.item?.nameItem || sub?.nameItem || it?.nameItem,
          unit:
            sub?.unit && typeof sub.unit === 'object'
              ? sub.unit
              : autoFetchPublicVersion?.unitArray.find((z) => {
                  const zVal = String(z?.value || '').toLowerCase()
                  const subVal = String(
                    sub?.unit?.value ||
                      sub?.unit ||
                      sub?.item?.unit ||
                      it?.unit?.value ||
                      it?.unit ||
                      '',
                  ).toLowerCase()
                  return zVal === subVal
                }),
          inventoryId: sub?.id || sub?.inventoryId || it?.inventoryId,
          packingId: sub?.groupId || it?.packingId || null,
          fieldNum: it?.orderItemId,
          lotCode:
            sub?.lotCode ||
            sub?.lot ||
            (sub?.lots && sub.lots.length > 0
              ? sub.lots.reduce((latest, current) => {
                  if (!latest?.data?.createdAt) return current
                  return new Date(current.data.createdAt) >
                    new Date(latest.data.createdAt)
                    ? current
                    : latest
                }, sub.lots[0])?.data?.lotCode
              : it?.lotCode || null) ||
            it?.lotCode ||
            null,
          ownerCode: sub?.ownerCode || it?.ownerCode || null,
          sourceGroupName: sub?.sourceGroupName || it?.sourceGroupName || null,
        })
      })
    })

    const mergedPacking = [...currentPacking, ...backfilledPacking].sort(
      (a, b) => Number(a?.fieldNum || 0) - Number(b?.fieldNum || 0),
    )

    dispatch(setInvPacking(mergedPacking))
  }, [dispatch, invPacking, orders?.item])

  // Handler for opening group picker modal
  const handleOpenGroupPicker = async (groupData) => {
    setInitialGroupSelectedItemIds([])
    setPendingGroupSelection(groupData)
    setIsLoadingGroupItems(true)
    setShowGroupPickerModal(true)
    setGroupItems([])

    try {
      const collectedInventory = await collectInventoryRecursively(groupData)
      setGroupItems(collectedInventory || [])
    } catch (error) {
      console.error('Error fetching group items:', error)
      setGroupItems([])
    } finally {
      setIsLoadingGroupItems(false)
    }
  }

  // Handler for confirming selected items from group
  const handleConfirmGroupSelection = async (selectedItems) => {
    if (!selectedItems || selectedItems.length === 0) {
      setShowGroupPickerModal(false)
      return
    }

    const processGroupSelection = async () => {
      try {
        setLoading((prevState) => ({ ...prevState, inventory: true }))

        // Process selected items into invPacking
        await handleGetPack(selectedItems, fieldNum, pendingGroupSelection)

        // Mark orders.item[idx] as isPacking so InfoTotalAmount validation skips it
        const groupName =
          pendingGroupSelection?.nameItem ||
          pendingGroupSelection?.label ||
          pendingGroupSelection?.name ||
          ''
        const pseudoGroupInfo = {
          label: groupName,
          label2: groupName,
          nameItem: groupName,
          id: pendingGroupSelection?.id,
          itemId: pendingGroupSelection?.itemId,
          isPacking: true,
        }
        handleChange('nameItem', pseudoGroupInfo, idx, true, true)

        setShowGroupPickerModal(false)
        setPendingGroupSelection(null)
        setGroupItems([])
        setInitialGroupSelectedItemIds([])
      } catch (error) {
        console.error('Error processing group selection:', error)
      } finally {
        setLoading((prevState) => ({ ...prevState, inventory: false }))
      }
    }

    await processGroupSelection()
  }

  // Handler for selecting all items (original behavior)
  const handleSelectAllGroupItems = async () => {
    if (!pendingGroupSelection) {
      setShowGroupPickerModal(false)
      return
    }

    try {
      setLoading((prevState) => ({ ...prevState, inventory: true }))
      setShowGroupPickerModal(false)

      // Use already fetched groupItems if available, otherwise fetch again
      const itemsToProcess =
        groupItems.length > 0
          ? groupItems
          : await collectInventoryRecursively(pendingGroupSelection)

      await handleGetPack(itemsToProcess, fieldNum, pendingGroupSelection)

      // Mark orders.item[idx] as isPacking so InfoTotalAmount validation skips it
      const groupName =
        pendingGroupSelection?.nameItem ||
        pendingGroupSelection?.label ||
        pendingGroupSelection?.name ||
        ''
      const pseudoGroupInfo = {
        label: groupName,
        label2: groupName,
        nameItem: groupName,
        id: pendingGroupSelection?.id,
        itemId: pendingGroupSelection?.itemId,
        isPacking: true,
      }
      handleChange('nameItem', pseudoGroupInfo, idx, true, true)

      setPendingGroupSelection(null)
      setGroupItems([])
      setInitialGroupSelectedItemIds([])
    } catch (error) {
      console.error('Error selecting all group items:', error)
    } finally {
      setLoading((prevState) => ({ ...prevState, inventory: false }))
    }
  }

  const currentFieldItemsCount =
    invPacking?.filter((e) => e?.fieldNum === fieldNum).length || 0
  const isInventoryOriginItem =
    !!orders?.item?.[idx]?.isFromManageStock ||
    !!orders?.item?.[idx]?.itemDetail?.inventoryId
  const isHideDropdown = isInventory?.[idx]
    ? isInventoryOriginItem || currentFieldItemsCount > 0
    : !!orders?.item?.[idx]?.id
  const isInventoryLookupLoading = isLoading || loading?.inventory
  const isShowStandaloneInventoryLoader = loading?.inventory
  const isUseLegacyInventoryUI = false

  return (
    <Card className="border-0 p-0 mb-3">
      <CardBody className="p-0">
        {!invToTrx && !isHideDropdown && (
          <FormGroup>
            <Label>Kategori barang</Label>
            <Row>
              <Col>
                <div
                  onClick={() => {
                    dispatch(
                      resetItemToDefault({ type: 'komoditas_umum', fieldNum }),
                    )
                    setIsInventory((prev) => {
                      const updated = [...prev]
                      updated[idx] = false
                      return updated
                    })
                  }}
                  className={`d-flex justify-content-between align-items-center p-3 rounded border pointer ${!isInventory?.[idx] ? 'bg-primary-50 border-primary' : ''}`}
                >
                  Barang Umum
                  <Input
                    name={`category-${fieldNum}`}
                    id={`category-${fieldNum}`}
                    onClick={() => {
                      dispatch(
                        resetItemToDefault({
                          type: 'komoditas_umum',
                          fieldNum,
                        }),
                      )
                      setIsInventory((prev) => {
                        const updated = [...prev]
                        updated[idx] = false
                        return updated
                      })
                    }}
                    value={isInventory?.[idx]}
                    checked={isInventory?.[idx] === false}
                    type="radio"
                  />
                </div>
              </Col>
              <Col>
                <div
                  onClick={() => {
                    dispatch(
                      resetItemToDefault({ type: 'inventori_anda', fieldNum }),
                    )
                    setIsInventory((prev) => {
                      const updated = [...prev]
                      updated[idx] = true
                      return updated
                    })
                  }}
                  className={`d-flex justify-content-between align-items-center p-3 rounded border pointer ${isInventory?.[idx] ? 'bg-primary-50 border-primary' : ''}`}
                >
                  Inventori Anda
                  <Input
                    name={`category-${fieldNum}`}
                    id={`category-${fieldNum}`}
                    onClick={() => {
                      dispatch(
                        resetItemToDefault({
                          type: 'inventori_anda',
                          fieldNum,
                        }),
                      )
                      setIsInventory((prev) => {
                        const updated = [...prev]
                        updated[idx] = true
                        return updated
                      })
                    }}
                    value={isInventory?.[idx]}
                    checked={isInventory?.[idx] === true}
                    type="radio"
                  />
                </div>
              </Col>
            </Row>
          </FormGroup>
        )}

        {isInventory?.[idx]
          ? (() => {
              const hasPackings = currentFieldItemsCount > 0
              const isSelected =
                orders?.item?.[idx]?.SKU !== '' &&
                !orders?.item?.[idx]?.isPacking
              const showBox = !isSelected && !hasPackings
              const titleName = 'Inventori Anda'
              const grpId = `inv_normal_${fieldNum}`
              const isGrpExp = expandedInvGroups[grpId] !== false
              const toggleGrp = () =>
                setExpandedInvGroups((p) => ({
                  ...p,
                  [grpId]: p[grpId] === false,
                }))

              const content = (
                <>
                  {!isHideDropdown && (
                    <FormGroup data-testid={`sell-form-item-select-${idx}`}>
                        <Label for="nameItem">Barang </Label>

                      <PMBSelect
                        menuPosition="fixed"
                        menuPlacement="bottom"
                        key={`select-${fieldNum}-${orders?.item[idx]?.inventoryId || 'empty'}`}
                        id="nameItem"
                        name="nameItem"
                        placeholder="Pilih barang"
                        inputValue={scannerSearchInput}
                        onInputChange={(val, { action }) => {
                          if (action === 'input-change') {
                            setScannerSearchInput(val)
                          }
                          return val
                        }}
                        menuIsOpen={menuIsOpen}
                        onMenuOpen={() => setMenuIsOpen(true)}
                        onMenuClose={() => setMenuIsOpen(false)}
                        options={getFilteredOptions() ?? []}
                        isLoading={isInventoryLookupLoading}
                        onChange={async (e) => {
                          try {
                            setScannerSearchInput('')
                            if (e?.isPacking) {
                              // Open group picker modal to let user select individual items
                              handleOpenGroupPicker(e)
                            } else {
                              handleSelectInventoryItem(e, idx, fieldNum)
                            }
                          } catch (error) {
                            console.error('Error in onChange:', error)
                          }
                        }}
                        formatOptionLabel={(data) => {
                          const isInventory = data?.amount !== undefined
                          const ownerCode = data?.ownerCode
                          const lotCode = data?.lotCode
                          const projectLabel = data?.projectLabel
                          if (isInventory) {
                            return (
                              <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center">
                                <div
                                  style={{
                                    width: '100%',
                                    wordWrap: 'break-word',
                                  }}
                                  className="mb-2 mb-md-0"
                                >
                                  <div>{data.nameItem}</div>
                                  <div
                                    className="text-muted"
                                    style={{
                                      fontSize: '0.85em',
                                      marginTop: '2px',
                                    }}
                                  >
                                    <span>
                                      Kode Inventori: {ownerCode ?? '-'}
                                    </span>
                                    <span className="ms-2 me-2"> • </span>
                                    <span>Lot ID: {lotCode ?? '-'}</span>
                                  </div>
                                  {projectLabel && (
                                    <div
                                      style={{
                                        fontSize: '0.8em',
                                        marginTop: '2px',
                                      }}
                                    >
                                      <span
                                        className="badge"
                                        style={{
                                          backgroundColor: '#E8F5E9',
                                          color: '#2E7D32',
                                          fontWeight: 500,
                                          fontSize: '0.85em',
                                          padding: '2px 8px',
                                          borderRadius: '4px',
                                        }}
                                      >
                                        Project: {projectLabel}
                                      </span>
                                    </div>
                                  )}
                                </div>
                                <div
                                  className="text-muted d-flex flex-wrap align-items-center justify-content-start justify-content-md-end"
                                  style={{ width: '100%', gap: '0.5rem' }}
                                >
                                  <span
                                    style={{
                                      whiteSpace: 'nowrap',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                    }}
                                  >
                                    {intl.formatNumber(data.amount, {
                                      useGrouping: 'always',
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    })}{' '}
                                    {data.unit}
                                  </span>
                                  <span className="d-none d-md-inline">|</span>
                                  <span style={{ wordWrap: 'break-word' }}>
                                    {data.warehouse}
                                  </span>
                                </div>
                              </div>
                            )
                          } else {
                            return (
                              <div className="d-flex justify-content-between align-items-center">
                                <div
                                  style={{
                                    flex: 1,
                                    minWidth: 0,
                                    overflow: 'hidden',
                                  }}
                                >
                                  <span
                                    style={{
                                      display: 'block',
                                      overflow: 'hidden',
                                      textOverflow: 'ellipsis',
                                      whiteSpace: 'nowrap',
                                    }}
                                  >
                                    {data.nameItem}
                                  </span>
                                </div>
                                <div
                                  className="text-muted"
                                  style={{
                                    flex: 1,
                                    minWidth: 0,
                                    textAlign: 'right',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                  }}
                                >
                                  {data.warehouseName}
                                </div>
                              </div>
                            )
                          }
                        }}
                        filterOption={(option, inputValue) => {
                          const label = option.label?.toLowerCase() || ''
                          const warehouse =
                            option.data?.warehouse?.toLowerCase() || ''
                          const warehouseName =
                            option.data?.warehouseName?.toLowerCase() || ''
                          const ownerCode =
                            option.data?.ownerCode?.toLowerCase() || ''
                          const lotCode =
                            option.data?.lotCode?.toLowerCase() || ''
                          const projectLabel =
                            option.data?.projectLabel?.toLowerCase() || ''
                          return (
                            label.includes(inputValue.toLowerCase()) ||
                            warehouse.includes(inputValue.toLowerCase()) ||
                            warehouseName.includes(inputValue.toLowerCase()) ||
                            ownerCode.includes(inputValue.toLowerCase()) ||
                            lotCode.includes(inputValue.toLowerCase()) ||
                            projectLabel.includes(inputValue.toLowerCase())
                          )
                        }}
                        value={(() => {
                          const currentItem = orders?.item[idx]

                          // If it's a packing/group, try to find it in GRUP INVENTORI
                          if (currentItem?.isPacking && currentItem?.id) {
                            if (String(currentItem.id).startsWith('pseudo-')) {
                              return {
                                label: currentItem.nameItem,
                                nameItem: currentItem.nameItem,
                                isPacking: true,
                                id: currentItem.id,
                                itemId: currentItem.itemId,
                                value: currentItem.id,
                              }
                            }

                            if (listInventories?.[0]?.options?.length > 0) {
                              const groupOption =
                                listInventories[0].options.find(
                                  (opt) =>
                                    Number(opt.id) === Number(currentItem.id),
                                )
                              if (groupOption) return groupOption
                            }
                          }

                          if (!currentItem?.inventoryId) return null

                          let selectedOption = null

                          // Try matching by inventoryId first
                          if (listInventories?.[0]?.options?.length > 0) {
                            selectedOption = listInventories[0].options.find(
                              (opt) =>
                                String(opt.id) ===
                                String(currentItem.inventoryId),
                            )
                          }

                          if (
                            !selectedOption &&
                            listInventories?.[1]?.options?.length > 0
                          ) {
                            selectedOption = listInventories[1].options.find(
                              (opt) =>
                                String(opt.id) ===
                                String(currentItem.inventoryId),
                            )
                          }

                          // Fallback: if still no match, try matching by nameItem and itemId
                          if (!selectedOption && currentItem.itemId) {
                            if (listInventories?.[0]?.options?.length > 0) {
                              selectedOption = listInventories[0].options.find(
                                (opt) =>
                                  String(opt.itemId) ===
                                  String(currentItem.itemId),
                              )
                            }

                            if (
                              !selectedOption &&
                              listInventories?.[1]?.options?.length > 0
                            ) {
                              selectedOption = listInventories[1].options.find(
                                (opt) =>
                                  String(opt.itemId) ===
                                  String(currentItem.itemId),
                              )
                            }
                          }

                          return selectedOption || null
                        })()}
                      />
                    </FormGroup>
                  )}
                  {isShowStandaloneInventoryLoader ? (
                    <div
                      className="d-flex flex-column gap-2 p-3 rounded border mb-3"
                      style={{
                        backgroundColor: '#f8fbff',
                        minHeight: '120px',
                        borderStyle: 'dashed',
                        margin: '10px 0',
                      }}
                    >
                      <Skeleton width="100%" height="24px" borderRadius="4px" />
                      <Skeleton width="100%" height="40px" borderRadius="8px" />
                      <div className="d-flex justify-content-center mt-1">
                        <span
                          className="text-primary fw-medium"
                          style={{ fontSize: '0.8rem' }}
                        >
                          Menyiapkan data...
                        </span>
                      </div>
                    </div>
                  ) : null}

                  {orders?.item?.[idx]?.SKU !== '' &&
                  !orders?.item?.[idx]?.isPacking &&
                  !isShowStandaloneInventoryLoader &&
                  isUseLegacyInventoryUI &&
                  !isInventoryOriginItem ? (
                    <>
                      {/* section 1 */}
                      {invToTrx ? (
                        <>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <span>Barang</span>
                              </FormGroup>
                            </Col>

                            <Col md={6}>
                              <FormGroup className="text-end">
                                <span>{orders?.item[idx]?.nameItem}</span>
                              </FormGroup>
                            </Col>
                          </Row>

                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <span>Berat</span>
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup className="text-end">
                                <span>
                                  {intl.formatNumber(
                                    orders?.item[idx]?.amount ?? 0,
                                    {
                                      useGrouping: 'always',
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    },
                                  )}
                                  {orders?.item[idx]?.unit?.value}
                                </span>
                              </FormGroup>
                            </Col>
                          </Row>
                        </>
                      ) : (
                        <>
                          <div className="d-flex justify-content-end mb-2">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                color="link"
                                className="p-0 text-dark"
                              >
                                <MoreVertical size={20} />
                              </DropdownToggle>
                              <DropdownMenu end>
                                <DropdownItem onClick={handleOpenSplitModal}>
                                  Pisah
                                </DropdownItem>
                                <DropdownItem
                                  onClick={() => setShowAutoPickModal(true)}
                                >
                                  Auto Populate
                                </DropdownItem>
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </div>
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="amount">Berat</Label>
                                <PMBInputNumber
                                  key={`amount-input-${fieldNum}-${orders?.item[idx]?.inventoryId || 'no-inv'}-${orders?.item[idx]?.originalAmount || orders?.item[idx]?.amount || 'no-amount'}`}
                                  name="amount"
                                  testId={`sell-form-qty-${idx}`}
                                  value={orders?.item[idx]?.amount ?? ''}
                                  onChange={(e) =>
                                    handleChangeInputSeparator(
                                      e.target.value,
                                      'amount',
                                      idx,
                                    )
                                  }
                                  placeholder={intl.formatNumber(
                                    isNaN(orders?.item[idx]?.amount)
                                      ? 0
                                      : orders?.item[idx]?.amount,
                                    {
                                      useGrouping: 'always',
                                      minimumFractionDigits: 0,
                                      maximumFractionDigits: 2,
                                    },
                                  )}
                                  maxDecimalPlaces={6}
                                />
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup data-testid={`sell-form-unit-select-${idx}`}>
                                <Label for="unit">Satuan</Label>
                                <PMBSelect
                                  key={fieldNum}
                                  id="unit"
                                  isDisabled
                                  name="unit"
                                  placeholder="Pilih unit"
                                  options={
                                    autoFetchPublicVersion?.unitArray ?? []
                                  }
                                  onChange={(e) => handleChange('unit', e, idx)}
                                  value={orders?.item[idx]?.unit}
                                  defaultValue={orders?.item[idx]?.unit}
                                />
                              </FormGroup>
                            </Col>
                          </Row>
                          {/* section 2 */}
                          <Row>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="price">Harga per satuan</Label>
                                <InputGroup>
                                  <InputGroupText className="bg-transparent">
                                    Rp
                                  </InputGroupText>
                                  <AmountInput
                                    name="price"
                                    idx={idx}
                                    cb={handleChangeInputSeparator}
                                    placeholder="0"
                                    dotOnly
                                    value={orders?.item[idx]?.price}
                                    testId={`sell-form-price-${idx}`}
                                  />
                                </InputGroup>

                                {/* SHOW SET PRICE PER SATUAN for matching base commodities */}
                                {(() => {
                                  const currentItem = orders?.item?.[idx]
                                  const currentBaseId =
                                    currentItem?.itemId || currentItem?.id
                                  if (!currentBaseId) return null
                                  const currentUnit = currentItem?.unit?.value
                                  const matchingItems = orders?.item?.filter(
                                    (item, i) =>
                                      i !== idx &&
                                      (item?.itemId || item?.id) &&
                                      String(item?.itemId || item?.id) ===
                                        String(currentBaseId) &&
                                      item?.unit?.value === currentUnit &&
                                      !item?.isPacking,
                                  )
                                  if (
                                    !matchingItems ||
                                    matchingItems.length === 0
                                  )
                                    return null
                                  return (
                                    <Row className="mt-2">
                                      <Col>
                                        <CustomButton
                                          className="w-100"
                                          color="primary"
                                          onClick={() =>
                                            handleSetPriceForAllItems()
                                          }
                                        >
                                          Terapkan ke semua{' '}
                                          {currentItem?.nameItem ?? ''}
                                        </CustomButton>
                                      </Col>
                                    </Row>
                                  )
                                })()}
                              </FormGroup>
                            </Col>
                            <Col md={6}>
                              <FormGroup>
                                <Label for="total">Total harga</Label>
                                <InputGroup>
                                  <InputGroupText className="bg-transparent">
                                    Rp
                                  </InputGroupText>
                                  <Input
                                    id="total"
                                    name="total"
                                    type="text"
                                    disabled
                                    placeholder={intl.formatNumber(
                                      isNaN(orders?.item[idx]?.totalPrice)
                                        ? 0
                                        : orders?.item[idx]?.totalPrice,
                                      {
                                        useGrouping: 'always',
                                        minimumFractionDigits: 0,
                                        maximumFractionDigits: 2,
                                      },
                                    )}
                                  />
                                </InputGroup>
                              </FormGroup>
                            </Col>
                            <Col md={12}>
                              <PriceReference 
                                itemId={orders?.item[idx]?.itemId || orders?.item[idx]?.id || orders?.item[idx]?.nameItem?.value}
                                currentPrice={orders?.item[idx]?.price}
                                currentUnit={orders?.item[idx]?.unit?.label || orders?.item[idx]?.unit?.value}
                                onUsePrice={(price, unit) => handleApplyPriceAndUnit(price, unit, idx)}
                              />
                            </Col>
                            <div className="d-flex justify-content-end">
                              <CustomButton
                                color="danger"
                                outline
                                className="d-flex align-items-center"
                                onClick={() => handleRemoveKomoditasUmum(fieldNum)}
                                size="sm"
                                testId={`sell-form-remove-item-${idx}`}
                              >
                                <Trash size={16} />
                              </CustomButton>
                            </div>
                          </Row>
                        </>
                      )}
                    </>
                  ) : (
                    <>
                      <div className="d-flex gap-3 flex-column">
                        {(() => {
                          // Filter items for the current fieldNum and preserve their original index in invPacking
                          const currentFieldItems =
                            invPacking
                              ?.map((e, index) => ({
                                ...e,
                                originalIndex: index,
                              }))
                              ?.filter((e) => e?.fieldNum === fieldNum) || []

                          // Group items by itemId and unit
                          const groupedItems = {}
                          currentFieldItems.forEach((item) => {
                            const groupKey = `${item?.itemId}_${item?.unit?.value || item?.unit}`
                            if (!groupedItems[groupKey]) {
                              groupedItems[groupKey] = {
                                items: [],
                                nameItem: item?.nameItem,
                                itemId: item?.itemId,
                                sourceGroupName: item?.sourceGroupName,
                                totalAmount: 0,
                                totalPrice: 0,
                              }
                            }
                            groupedItems[groupKey].items.push(item)

                            // Aggressively capture group name if not already set
                            if (
                              !groupedItems[groupKey].sourceGroupName &&
                              (item.sourceGroupName ||
                                item.groupName ||
                                item.group?.nameItem ||
                                item.group?.name)
                            ) {
                              groupedItems[groupKey].sourceGroupName =
                                item.sourceGroupName ||
                                item.groupName ||
                                item.group?.nameItem ||
                                item.group?.name
                            }

                            const numericAmount =
                              typeof item.amount === 'string'
                                ? Number(
                                    item.amount
                                      ?.replace(/\./g, '')
                                      ?.replace(/\,/g, '.')
                                      ?.slice(0, 15),
                                  ) || 0
                                : Number(item.amount) || 0

                            groupedItems[groupKey].totalAmount += numericAmount
                            groupedItems[groupKey].totalPrice +=
                              Number(item.totalPrice) || 0
                          })

                          return Object.entries(groupedItems).map(
                            ([groupKey, group], groupIndex) => {
                              const isGroupExpanded =
                                expandedInvGroups[`${fieldNum}-${groupKey}`]
                              const rawGroupName = (
                                group?.nameItem ||
                                group?.items?.find((it) => it?.nameItem)
                                  ?.nameItem ||
                                ''
                              )
                                .toString()
                                .trim()
                              const firstInventoryId =
                                group?.items?.[0]?.inventoryId
                              const inventoryNameFromMaster = (
                                inventories || []
                              ).find(
                                (inv) =>
                                  String(inv?.id) === String(firstInventoryId),
                              )?.nameItem
                              const isGroupNameLoading =
                                !rawGroupName &&
                                !!firstInventoryId &&
                                isInventoryLookupLoading
                              const resolvedGroupName =
                                rawGroupName ||
                                inventoryNameFromMaster ||
                                (firstInventoryId
                                  ? `Inventori #${firstInventoryId}`
                                  : '')
                              const groupProjects = [
                                ...new Set(
                                  group.items
                                    .map((it) => it?.projectLabel)
                                    .filter(Boolean),
                                ),
                              ]
                              const toggleGroup = () => {
                                setExpandedInvGroups((prev) => ({
                                  ...prev,
                                  [`${fieldNum}-${groupKey}`]:
                                    !prev[`${fieldNum}-${groupKey}`],
                                }))
                              }

                              const isShowButton =
                                group.items.length > 1 && !!group.itemId

                              return (
                                <div
                                  key={groupKey}
                                  className="bg-light p-2 rounded border border-gray-200"
                                >
                                  {/* GROUP HEADER */}
                                  <div
                                    className="d-flex justify-content-between align-items-center"
                                    style={{
                                      cursor: 'pointer',
                                      minHeight: '42px',
                                    }}
                                    onClick={toggleGroup}
                                  >
                                    <div
                                      className="d-flex align-items-center flex-grow-1 pe-2 overflow-hidden gap-2"
                                      style={{ minWidth: 0 }}
                                    >
                                      {isGroupNameLoading ? (
                                        <div
                                          className="d-flex align-items-center gap-2"
                                          style={{ minWidth: 0 }}
                                        >
                                          <span
                                            className="spinner-border spinner-border-sm text-primary"
                                            role="status"
                                            aria-hidden="true"
                                          ></span>
                                          <span
                                            className="fw-semibold text-muted text-truncate d-block"
                                            style={{
                                              minWidth: 0,
                                              maxWidth: '100%',
                                              lineHeight: 1.2,
                                            }}
                                          >
                                            Memuat nama inventori...
                                          </span>
                                        </div>
                                      ) : (
                                        <div
                                          className="d-flex flex-column"
                                          style={{ minWidth: 0 }}
                                        >
                                          <span
                                            className="fw-semibold d-block text-truncate"
                                            style={{
                                              minWidth: 0,
                                              maxWidth: '100%',
                                              lineHeight: 1.2,
                                              whiteSpace: 'normal',
                                              wordBreak: 'break-word',
                                            }}
                                            title={resolvedGroupName}
                                          >
                                            {resolvedGroupName}
                                          </span>
                                          {groupProjects.length > 0 && (
                                            <span
                                              className="text-muted d-flex align-items-center gap-1 mt-1"
                                              style={{ fontSize: '0.8rem' }}
                                              title={groupProjects.join(', ')}
                                            >
                                              <Folder size={12} />
                                              {groupProjects[0]}
                                              {groupProjects.length > 1 &&
                                                ` +${groupProjects.length - 1}`}
                                            </span>
                                          )}
                                        </div>
                                      )}
                                      <span className="badge bg-primary flex-shrink-0">
                                        {group.items.length} item
                                        {group.items.length > 1 ? '(s)' : ''}
                                      </span>
                                      <span className="badge bg-secondary text-white flex-shrink-0">
                                        Inventori Anda
                                      </span>
                                    </div>
                                    <div className="d-flex align-items-center flex-shrink-0 gap-3">
                                      <div className="text-primary d-flex align-items-center">
                                        {isGroupExpanded ? (
                                          <ChevronUp size={20} />
                                        ) : (
                                          <ChevronDown size={20} />
                                        )}
                                      </div>
                                      <CustomButton
                                        className="p-1 px-2 d-flex align-items-center position-relative"
                                        color="danger"
                                        outline
                                        size="sm"
                                        testId={`sell-form-remove-item-${idx}`}
                                        onClick={(e) => {
                                          e.stopPropagation()
                                          handleRemoveSpecificInventories(
                                            group.items.map(
                                              (item) => item.inventoryId,
                                            ),
                                            fieldNum,
                                          )
                                        }}
                                      >
                                        <Trash size={16} />
                                      </CustomButton>
                                    </div>
                                  </div>

                                  {isGroupNameLoading ? (
                                    <div className="d-flex align-items-center gap-2 mt-2">
                                      <span
                                        className="spinner-border spinner-border-sm text-primary"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span
                                        className="text-muted"
                                        style={{ fontSize: '0.85rem' }}
                                      >
                                        Menyiapkan detail inventori...
                                      </span>
                                    </div>
                                  ) : (
                                    <div className="d-flex justify-content-between align-items-center mt-auto">
                                      <span
                                        className="fw-semibold text-muted"
                                        style={{ fontSize: '0.85rem' }}
                                      >
                                        Total Berat:{' '}
                                        {intl.formatNumber(group.totalAmount, {
                                          useGrouping: 'always',
                                          minimumFractionDigits: 0,
                                          maximumFractionDigits: 2,
                                        })}{' '}
                                        {group.items[0]?.unit?.label ||
                                          group.items[0]?.unit}
                                      </span>
                                      {!invToTrx && (
                                        <span
                                          className="text-primary fw-semibold"
                                          style={{ fontSize: '0.85rem' }}
                                        >
                                          Total: Rp
                                          {intl.formatNumber(group.totalPrice, {
                                            useGrouping: 'always',
                                            minimumFractionDigits: 0,
                                            maximumFractionDigits: 0,
                                          })}
                                        </span>
                                      )}
                                    </div>
                                  )}

                                  <Collapse
                                    isOpen={
                                      isGroupExpanded && !isGroupNameLoading
                                    }
                                  >
                                    <div className="pt-2 mt-2 border-top">
                                      {group.items.map((e, idxInGroup) => {
                                        const i = e.originalIndex
                                        const inventorySourceGroupName =
                                          resolveSourceGroupName(e)
                                        const hasInventorySourceGroupName =
                                          !!inventorySourceGroupName

                                        return (
                                          <div
                                            key={i}
                                            className={`bg-white rounded border mb-3 position-relative ${
                                              hasInventorySourceGroupName
                                                ? 'p-3'
                                                : 'pt-3 px-3 pb-2'
                                            }`}
                                          >
                                            {invToTrx ? (
                                              <Row>
                                                <Col md={6}>
                                                  <FormGroup className="mb-0">
                                                    <span>Barang</span>
                                                  </FormGroup>
                                                </Col>

                                                <Col md={6}>
                                                  <FormGroup className="text-end d-flex flex-column align-items-end mb-0">
                                                    <span
                                                      style={{
                                                        whiteSpace: 'normal',
                                                        wordBreak: 'break-word',
                                                      }}
                                                      title={e?.nameItem}
                                                    >
                                                      {e?.nameItem}
                                                    </span>
                                                    {hasInventorySourceGroupName && (
                                                      <span
                                                        className="badge bg-info text-dark mt-1"
                                                        style={{
                                                          maxWidth: '220px',
                                                          whiteSpace: 'nowrap',
                                                          overflow: 'hidden',
                                                          textOverflow:
                                                            'ellipsis',
                                                        }}
                                                        title={
                                                          inventorySourceGroupName
                                                        }
                                                      >
                                                        Grup:{' '}
                                                        {
                                                          inventorySourceGroupName
                                                        }
                                                      </span>
                                                    )}
                                                    <CustomButton
                                                      color="danger"
                                                      outline
                                                      size="sm"
                                                      testId={`sell-form-remove-item-${idx}`}
                                                      className={`p-1 px-2 d-flex align-items-center position-relative ${
                                                        hasInventorySourceGroupName
                                                          ? 'mt-2'
                                                          : ''
                                                      }`}
                                                      onClick={(event) => {
                                                        event.stopPropagation()
                                                        handleRemoveSpecificInventories(
                                                          [e?.inventoryId],
                                                          fieldNum,
                                                        )
                                                      }}
                                                    >
                                                      <Trash size={16} />
                                                    </CustomButton>
                                                  </FormGroup>
                                                </Col>
                                              </Row>
                                            ) : (
                                              <>
                                                <div
                                                  className="d-flex align-items-center gap-2 position-absolute"
                                                  style={{
                                                    top: '12px',
                                                    right: '12px',
                                                  }}
                                                >
                                                  <CustomButton
                                                    color="primary"
                                                    outline
                                                    size="sm"
                                                    className="p-1 px-2 d-flex align-items-center"
                                                    onClick={(event) => {
                                                      event.stopPropagation()
                                                      handleOpenSplitModal(e)
                                                    }}
                                                  >
                                                    Pisah
                                                  </CustomButton>
                                                  <UncontrolledDropdown>
                                                    <DropdownToggle
                                                      color="link"
                                                      className="p-0 text-dark"
                                                      onClick={(evt) =>
                                                        evt.stopPropagation()
                                                      }
                                                    >
                                                      <MoreVertical size={20} />
                                                    </DropdownToggle>
                                                    <DropdownMenu end>
                                                      <DropdownItem
                                                        onClick={(evt) => {
                                                          evt.stopPropagation()
                                                          setShowAutoPickModal(
                                                            true,
                                                          )
                                                        }}
                                                      >
                                                        Auto Populate
                                                      </DropdownItem>
                                                    </DropdownMenu>
                                                  </UncontrolledDropdown>
                                                  <CustomButton
                                                    color="danger"
                                                    outline
                                                    size="sm"
                                                    className="p-1 px-2 d-flex align-items-center"
                                                    testId={`sell-form-remove-item-${idx}`}
                                                    onClick={(event) => {
                                                      event.stopPropagation()
                                                      handleRemoveSpecificInventories(
                                                        [e?.inventoryId],
                                                        fieldNum,
                                                      )
                                                    }}
                                                  >
                                                    <Trash size={16} />
                                                  </CustomButton>
                                                </div>

                                                {(e?.nameItem ||
                                                  hasInventorySourceGroupName) && (
                                                  <div
                                                    className="d-flex flex-column gap-2 text-start mb-3"
                                                    style={{
                                                      paddingRight: '40px',
                                                    }}
                                                  >
                                                    {e?.nameItem && (
                                                      <div className="d-flex flex-column">
                                                        <span className="fw-semibold">
                                                          {e?.nameItem}
                                                        </span>
                                                        {(e?.ownerCode ||
                                                          e?.lotCode) && (
                                                          <div
                                                            className="text-muted"
                                                            style={{
                                                              fontSize:
                                                                '0.75rem',
                                                              marginTop: '2px',
                                                            }}
                                                          >
                                                            {e?.ownerCode && (
                                                              <span>
                                                                Kode:{' '}
                                                                {e.ownerCode}
                                                              </span>
                                                            )}
                                                            {e?.ownerCode &&
                                                              e?.lotCode && (
                                                                <span className="mx-1">
                                                                  •
                                                                </span>
                                                              )}
                                                            {e?.lotCode && (
                                                              <span>
                                                                Lot: {e.lotCode}
                                                              </span>
                                                            )}
                                                          </div>
                                                        )}
                                                      </div>
                                                    )}
                                                    {hasInventorySourceGroupName && (
                                                      <span
                                                        className="badge bg-info text-dark text-wrap text-start"
                                                        style={{
                                                          maxWidth: '220px',
                                                          width: 'fit-content',
                                                          overflow: 'hidden',
                                                          textOverflow:
                                                            'ellipsis',
                                                        }}
                                                        title={
                                                          inventorySourceGroupName
                                                        }
                                                      >
                                                        Grup:{' '}
                                                        {
                                                          inventorySourceGroupName
                                                        }
                                                      </span>
                                                    )}
                                                  </div>
                                                )}
                                              </>
                                            )}

                                            <Row>
                                              <Col md={6}>
                                                <FormGroup>
                                                  <Label for="amount">
                                                    Berat
                                                    <span
                                                      className="mx-1 text-muted"
                                                      style={{
                                                        fontSize: '0.7rem',
                                                      }}
                                                    >
                                                      {(() => {
                                                        const resolvedInventoryAmount =
                                                          (
                                                            inventories || []
                                                          ).find(
                                                            (inv) =>
                                                              String(
                                                                inv?.id,
                                                              ) ===
                                                              String(
                                                                e?.inventoryId ||
                                                                  e?.id,
                                                              ),
                                                          )?.amount
                                                        const maxAmount =
                                                          resolvedInventoryAmount ??
                                                          e?.originalAmount ??
                                                          e?.amount

                                                        return ` (Berat maksimal ${newFormatThousandSeparator(
                                                          maxAmount,
                                                        )})`
                                                      })()}
                                                    </span>
                                                  </Label>
                                                  <PMBInputNumber
                                                    key={`amount-group-${e.inventoryId}`}
                                                    name="amount"
                                                    testId={`sell-form-qty-${idx}`}
                                                    value={
                                                      typeof e?.amount ===
                                                      'number'
                                                        ? intl.formatNumber(
                                                            e?.amount,
                                                            {
                                                              useGrouping:
                                                                'always',
                                                              minimumFractionDigits: 0,
                                                              maximumFractionDigits: 2,
                                                            },
                                                          )
                                                        : (e?.amount ?? '')
                                                    }
                                                    onChange={(event) =>
                                                      handleChangeInputSeparator(
                                                        event.target.value,
                                                        'amount',
                                                        i,
                                                        e,
                                                      )
                                                    }
                                                    placeholder="0"
                                                    maxDecimalPlaces={6}
                                                    maxValue={parseNumber(
                                                      (() => {
                                                        const resolvedInventoryAmount =
                                                          (
                                                            inventories || []
                                                          ).find(
                                                            (inv) =>
                                                              String(
                                                                inv?.id,
                                                              ) ===
                                                              String(
                                                                e?.inventoryId ||
                                                                  e?.id,
                                                              ),
                                                          )?.amount
                                                        return (
                                                          resolvedInventoryAmount ??
                                                          e?.originalAmount ??
                                                          e?.amount
                                                        )
                                                      })(),
                                                    )}
                                                  />
                                                </FormGroup>
                                              </Col>
                                              <Col md={6}>
                                                <FormGroup data-testid={`sell-form-unit-select-${idx}`}>
                                                  <Label for="unit">
                                                    Satuan
                                                  </Label>
                                                  <PMBSelect
                                                    id="unit"
                                                    isDisabled
                                                    name="unit"
                                                    placeholder="Pilih unit"
                                                    options={
                                                      autoFetchPublicVersion?.unitArray ??
                                                      []
                                                    }
                                                    value={e?.unit}
                                                  />
                                                </FormGroup>
                                              </Col>
                                            </Row>

                                            {!invToTrx && (
                                              <>
                                                <Row>
                                                  <Col md={6}>
                                                    <FormGroup
                                                      className={
                                                        hasInventorySourceGroupName
                                                          ? ''
                                                          : 'mb-1'
                                                      }
                                                    >
                                                      <div className="d-flex justify-content-between align-items-center">
                                                        <Label
                                                          for="price"
                                                          className="mb-0"
                                                        >
                                                          Harga per satuan
                                                        </Label>
                                                        {isShowButton && (
                                                          <>
                                                            <CustomButton
                                                              id={`terapkan-${e.inventoryId}`}
                                                              size="sm"
                                                              color="link"
                                                              className="p-0 text-decoration-none d-flex align-items-center gap-1"
                                                              aria-label={`Terapkan harga ke semua ${group.nameItem ?? ''}`.trim()}
                                                              onClick={() =>
                                                                handleSetPricePerSatuan(
                                                                  group.itemId,
                                                                  e.price,
                                                                )
                                                              }
                                                            >
                                                              <Copy
                                                                size={16}
                                                                className="text-secondary"
                                                              />
                                                              <span className="small text-secondary fw-semibold">
                                                                Terapkan
                                                              </span>
                                                            </CustomButton>
                                                            <UncontrolledTooltip
                                                              target={`terapkan-${e.inventoryId}`}
                                                            >
                                                              Terapkan ke semua{' '}
                                                              {group.nameItem ??
                                                                ''}
                                                            </UncontrolledTooltip>
                                                          </>
                                                        )}
                                                      </div>
                                                      <InputGroup className="mt-1">
                                                        <InputGroupText className="bg-transparent">
                                                          Rp
                                                        </InputGroupText>
                                                        <AmountInput
                                                          name="price"
                                                          idx={i}
                                                          key={`price-input-${e.inventoryId}-${priceVersions[e.inventoryId] || 0}`}
                                                          testId={`sell-form-price-${idx}`}
                                                          value={
                                                            e?.price
                                                              ? intl.formatNumber(
                                                                  e?.price,
                                                                  {
                                                                    useGrouping:
                                                                      'always',
                                                                    minimumFractionDigits: 0,
                                                                    maximumFractionDigits: 0,
                                                                  },
                                                                )
                                                              : ''
                                                          }
                                                          cb={(w) =>
                                                            handleChangeInputSeparator(
                                                              w,
                                                              'price',
                                                              i,
                                                              e,
                                                            )
                                                          }
                                                          placeholder="0"
                                                          dotOnly
                                                        />
                                                      </InputGroup>

                                                    </FormGroup>
                                                  </Col>
                                                  <Col md={6}>
                                                    <FormGroup
                                                      className={
                                                        hasInventorySourceGroupName
                                                          ? ''
                                                          : 'mb-1'
                                                      }
                                                    >
                                                      <Label for="total">
                                                        Total harga
                                                      </Label>
                                                      <InputGroup>
                                                        <InputGroupText className="bg-transparent">
                                                          Rp
                                                        </InputGroupText>
                                                        <Input
                                                          id="total"
                                                          name="total"
                                                          type="text"
                                                          disabled
                                                          placeholder={intl.formatNumber(
                                                            isNaN(e?.totalPrice)
                                                              ? 0
                                                              : e?.totalPrice,
                                                            {
                                                              useGrouping:
                                                                'always',
                                                              minimumFractionDigits: 0,
                                                              maximumFractionDigits: 2,
                                                            },
                                                          )}
                                                        />
                                                      </InputGroup>
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md={12}>
                                                    <PriceReference 
                                                      itemId={group?.itemId}
                                                      currentPrice={e?.price}
                                                      currentUnit={e?.unit?.label || e?.unit?.value}
                                                      onUsePrice={(price, unit) => handleApplyPriceAndUnit(price, unit, i, e)}
                                                    />
                                                  </Col>
                                                </Row>
                                              </>
                                            )}
                                          </div>
                                        )
                                      })}
                                    </div>
                                  </Collapse>
                                </div>
                              )
                            },
                          )
                        })()}
                        {!isHideDropdown && !showBox && (
                          <div className="d-flex justify-content-end">
                            <CustomButton
                              color="danger"
                              outline
                              className="d-flex align-items-center"
                              onClick={() => handleRemoveKomoditasUmum(fieldNum)}
                              size="sm"
                              testId={`sell-form-remove-item-${idx}`}
                            >
                              <Trash size={16} />
                            </CustomButton>
                          </div>
                        )}
                      </div>
                    </>
                  )}
                </>
              )

              if (showBox) {
                return (
                  <div
                    className="bg-light p-2 rounded border border-gray-200 d-flex flex-column"
                    style={isGrpExp ? undefined : { height: '118px' }}
                  >
                    {/* GROUP HEADER */}
                    <div
                      className="d-flex justify-content-between align-items-center"
                      style={{ cursor: 'pointer', minHeight: '42px' }}
                      onClick={toggleGrp}
                    >
                      <div
                        className="d-flex align-items-center flex-grow-1 pe-2 overflow-hidden gap-2"
                        style={{ minWidth: 0 }}
                      >
                        <span
                          className="fw-semibold text-truncate d-block"
                          style={{
                            minWidth: 0,
                            maxWidth: '100%',
                            lineHeight: 1.2,
                          }}
                        >
                          {titleName}
                        </span>
                        <span className="badge bg-secondary text-white flex-shrink-0">
                          Inventori Anda
                        </span>
                      </div>
                      <div className="d-flex align-items-center flex-shrink-0 gap-3">
                        <div className="text-primary d-flex align-items-center">
                          {isGrpExp ? (
                            <ChevronUp size={20} />
                          ) : (
                            <ChevronDown size={20} />
                          )}
                        </div>
                        <CustomButton
                          className="p-1 px-2 d-flex align-items-center position-relative"
                          color="danger"
                          outline
                          testId={`sell-form-remove-item-${idx}`}
                          onClick={(e) => {
                            e.stopPropagation()
                            if (fieldNum) {
                              handleRemoveSpecificInventories(
                                (invPacking || [])
                                  .filter((item) => Number(item?.fieldNum) === Number(fieldNum))
                                  .map((item) => item?.inventoryId),
                                fieldNum,
                              )
                            }
                          }}
                          size="sm"
                        >
                          <Trash size={16} />
                        </CustomButton>
                      </div>
                    </div>

                    <Collapse isOpen={isGrpExp}>
                      <div className="pt-2 mt-2 border-top">
                        <div className="bg-white p-3 rounded border mb-0">
                          {content}
                        </div>
                      </div>
                    </Collapse>
                  </div>
                )
              }

              return content
            })()
          : (() => {
              const currentItem = orders?.item?.[idx]
              const currentId = currentItem?.id

              let matchingIndices = [idx]
              if (currentId) {
                matchingIndices = orders?.item
                  ?.map((it, i) =>
                    it?.id === currentId && isInventory?.[i] === false ? i : -1,
                  )
                  .filter((i) => i !== -1)
              }

              // Only render if it's the first occurrence of this commodity, or if it has no id yet
              const isFirstOfItsKind = currentId
                ? matchingIndices[0] === idx
                : true

              if (!isFirstOfItsKind) return null

              const isGroupExpanded =
                expandedInvGroups[`komoditas_umum_${fieldNum}`] !== false
              const toggleGroup = () => {
                setExpandedInvGroups((prev) => ({
                  ...prev,
                  [`komoditas_umum_${fieldNum}`]:
                    prev[`komoditas_umum_${fieldNum}`] === false,
                }))
              }

              const komoditasName =
                listComodities?.[0]?.options?.find((i) => i.value === currentId)
                  ?.label ||
                listComodities?.[1]?.options?.find((i) => i.value === currentId)
                  ?.label ||
                'Barang Umum'

              let groupTotalWeight = 0
              let groupTotalPrice = 0

              matchingIndices.forEach((mIdx) => {
                const amountRaw = orders?.item?.[mIdx]?.amount
                const mAmount =
                  typeof amountRaw === 'string'
                    ? Number(
                        amountRaw
                          ?.replace(/\./g, '')
                          ?.replace(/\,/g, '.')
                          ?.slice(0, 15),
                      ) || 0
                    : Number(amountRaw) || 0
                groupTotalWeight += mAmount
                groupTotalPrice += Number(orders?.item?.[mIdx]?.totalPrice) || 0
              })

              const unitLabel =
                orders?.item?.[idx]?.unit?.label ||
                orders?.item?.[idx]?.unit?.value ||
                ''

              return (
                <div className="bg-light p-2 rounded border border-gray-200">
                  {/* GROUP HEADER */}
                  <div
                    className="d-flex justify-content-between align-items-center"
                    style={{ cursor: 'pointer', minHeight: '42px' }}
                    onClick={toggleGroup}
                  >
                    <div
                      className="d-flex align-items-center flex-grow-1 pe-2 overflow-hidden gap-2"
                      style={{ minWidth: 0 }}
                    >
                      <span
                        className="fw-semibold text-truncate d-block"
                        style={{
                          minWidth: 0,
                          maxWidth: '100%',
                          lineHeight: 1.2,
                        }}
                      >
                        {komoditasName}
                      </span>
                      {currentId && (
                        <span className="badge bg-primary flex-shrink-0">
                          {matchingIndices.length} item
                          {matchingIndices.length > 1 ? '(s)' : ''}
                        </span>
                      )}
                      <span className="badge bg-secondary text-white flex-shrink-0">
                        Barang Umum
                      </span>
                    </div>
                    <div className="d-flex align-items-center flex-shrink-0 gap-3">
                      <div className="text-primary d-flex align-items-center">
                        {isGroupExpanded ? (
                          <ChevronUp size={20} />
                        ) : (
                          <ChevronDown size={20} />
                        )}
                      </div>
                        <CustomButton
                          className="p-1 px-2 d-flex align-items-center position-relative"
                          color="danger"
                          outline
                          testId={`sell-form-remove-item-${idx}`}
                          onClick={(e) => {
                            e.stopPropagation()
                            handleRemoveKomoditasUmum(fieldNum, matchingIndices)
                          }}
                          size="sm"
                        >
                          <Trash size={16} />
                        </CustomButton>
                    </div>
                  </div>

                  {currentId && (
                    <div className="d-flex justify-content-between align-items-center px-1 mt-1">
                      <span
                        className="fw-semibold text-muted"
                        style={{ fontSize: '0.85rem' }}
                      >
                        Total Berat:{' '}
                        {intl.formatNumber(groupTotalWeight, {
                          useGrouping: 'always',
                          minimumFractionDigits: 0,
                          maximumFractionDigits: 2,
                        })}{' '}
                        {unitLabel}
                      </span>
                      {!invToTrx && (
                        <span
                          className="text-primary fw-semibold"
                          style={{ fontSize: '0.85rem' }}
                        >
                          Total: Rp
                          {intl.formatNumber(groupTotalPrice, {
                            useGrouping: 'always',
                            minimumFractionDigits: 0,
                            maximumFractionDigits: 0,
                          })}
                        </span>
                      )}
                    </div>
                  )}

                  <Collapse isOpen={isGroupExpanded}>
                    <div className="pt-2 mt-2 border-top">
                      <div className="bg-white p-3 rounded border mb-0">
                        {!currentId && (
                          <FormGroup data-testid={`sell-form-item-select-${idx}`}>
                            <Label for="nameItem">Barang</Label>
                            <PMBSelect
                              id="nameItem"
                              name="nameItem"
                              placeholder="Pilih barang"
                              inputValue={scannerSearchInput}
                              onInputChange={(val, { action }) => {
                                if (action === 'input-change') {
                                  setScannerSearchInput(val)
                                }
                                return val
                              }}
                              options={listComodities ?? []}
                              onChange={(e) => {
                                setScannerSearchInput('')
                                handleChange('nameItem', e, idx)
                                handleLastPick(e)
                              }}
                              value={
                                listComodities?.[0]?.options?.find(
                                  (i) => i.value === currentId,
                                ) ||
                                listComodities?.[1]?.options?.find(
                                  (i) => i.value === currentId,
                                )
                              }
                              ref={refItem}
                              menuPlacement="bottom"
                              menuPosition="fixed"
                            />
                          </FormGroup>
                        )}

                        {currentId &&
                          matchingIndices.map((mIdx, loopIndex) => (
                            <div
                              key={`mIdx-${mIdx}`}
                              className={
                                loopIndex > 0 ? 'pt-3 mt-3 border-top' : ''
                              }
                            >
                              {invToTrx ? (
                                <Row>
                                  <Col md={6}>
                                    <FormGroup>
                                      <span>Barang</span>
                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup className="text-end">
                                      <span>{komoditasName}</span>
                                    </FormGroup>
                                  </Col>
                                </Row>
                              ) : (
                                <Row className="fw-semibold mb-2">
                                  <Col md={12}>
                                    <span>{komoditasName}</span>
                                  </Col>
                                </Row>
                              )}
                              <Row>
                                <Col md={6}>
                                  <FormGroup>
                                    <Label>Berat</Label>
                                    <PMBInputNumber
                                      name="amount"
                                      testId={`sell-form-qty-${idx}`}
                                      value={orders?.item[mIdx]?.amount ?? ''}
                                      onChange={(e) =>
                                        handleChangeInputSeparator(
                                          e.target.value,
                                          'amount',
                                          mIdx,
                                        )
                                      }
                                      placeholder="0"
                                      maxDecimalPlaces={6}
                                    />
                                  </FormGroup>
                                </Col>
                                <Col md={6}>
                                  <FormGroup data-testid={`sell-form-unit-select-${idx}`}>
                                    <Label>Satuan</Label>
                                    <PMBSelect
                                      id="unit"
                                      name="unit"
                                      placeholder="Pilih unit"
                                      options={
                                        autoFetchPublicVersion?.unitArray ?? []
                                      }
                                      onChange={(e) =>
                                        handleChange('unit', e, mIdx)
                                      }
                                      value={orders?.item[mIdx]?.unit}
                                      defaultValue={orders?.item[mIdx]?.unit}
                                    />
                                  </FormGroup>
                                </Col>
                              </Row>

                              {!invToTrx && (
                                <Row>
                                  <Col md={6}>
                                    <FormGroup>
                                      <div className="d-flex justify-content-between align-items-center">
                                        <Label className="mb-0">
                                          Harga per satuan
                                        </Label>
                                        {matchingIndices.length > 1 && (
                                          <>
                                            <CustomButton
                                              id={`terapkan-umum-${mIdx}`}
                                              size="sm"
                                              color="link"
                                              className="p-0 text-decoration-none d-flex align-items-center gap-1"
                                              aria-label={`Terapkan harga ke semua ${komoditasName ?? ''}`.trim()}
                                              onClick={() =>
                                                handleSetPricePerSatuanUmum(
                                                  currentId,
                                                  orders?.item[mIdx]?.price,
                                                )
                                              }
                                            >
                                              <Copy
                                                size={16}
                                                className="text-secondary"
                                              />
                                              <span className="small text-secondary fw-semibold">
                                                Terapkan
                                              </span>
                                            </CustomButton>
                                            <UncontrolledTooltip
                                              target={`terapkan-umum-${mIdx}`}
                                            >
                                              Terapkan ke semua{' '}
                                              {komoditasName ?? ''}
                                            </UncontrolledTooltip>
                                          </>
                                        )}
                                      </div>
                                      <InputGroup className="mt-1">
                                        <InputGroupText className="bg-transparent">
                                          Rp
                                        </InputGroupText>
                                        <AmountInput
                                          name="price"
                                          idx={mIdx}
                                          key={`price-input-umum-${mIdx}-${priceVersions['umum-' + mIdx] || 0}`}
                                          testId={`sell-form-price-${idx}`}
                                          cb={handleChangeInputSeparator}
                                          placeholder="0"
                                          dotOnly
                                          value={orders?.item[mIdx]?.price}
                                        />
                                      </InputGroup>

                                    </FormGroup>
                                  </Col>
                                  <Col md={6}>
                                    <FormGroup>
                                      <Label>Total harga</Label>
                                      <InputGroup>
                                        <InputGroupText className="bg-transparent">
                                          Rp
                                        </InputGroupText>
                                        <Input
                                          type="text"
                                          disabled
                                          placeholder={intl.formatNumber(
                                            isNaN(
                                              orders?.item[mIdx]?.totalPrice,
                                            )
                                              ? 0
                                              : orders?.item[mIdx]?.totalPrice,
                                            {
                                              useGrouping: 'always',
                                              minimumFractionDigits: 0,
                                              maximumFractionDigits: 2,
                                            },
                                          )}
                                        />
                                      </InputGroup>
                                    </FormGroup>
                                  </Col>
                                  <Col md={12}>
                                    <PriceReference 
                                      itemId={orders?.item[mIdx]?.itemId || orders?.item[mIdx]?.id}
                                      currentPrice={orders?.item[mIdx]?.price}
                                      currentUnit={orders?.item[mIdx]?.unit?.label || orders?.item[mIdx]?.unit?.value}
                                      onUsePrice={(price, unit) => handleApplyPriceAndUnit(price, unit, mIdx)}
                                    />
                                  </Col>
                                </Row>
                              )}
                            </div>
                          ))}
                      </div>
                    </div>
                  </Collapse>
                </div>
              )
            })()}
      </CardBody>

      {/* Modal Split */}
      <ModalSplit
        isOpen={modalSplitOpen}
        toggle={handleCloseSplitModal}
        selectedItem={selectedItemForSplit}
        onSplitSuccess={handleSplitSuccess}
      />

      {/* Auto-pick Preview Modal */}
      <ModalAutoPick
        isOpen={showAutoPickModal}
        toggle={() => setShowAutoPickModal(false)}
        onApply={handleAutoPickApply}
        onClose={() => setShowAutoPickModal(false)}
        orderItem={orders?.item?.[idx]}
        orders={orders}
        inventories={inventories}
        packings={packings}
        invPacking={invPacking}
        addItemCount={addItemCount}
        idx={idx}
        fieldNum={fieldNum}
        intl={intl}
        autoFetchPublicVersion={autoFetchPublicVersion}
        dispatch={dispatch}
        loading={loading}
      />

      {/* Group Item Picker Modal */}
      <ModalGroupItemPicker
        isOpen={showGroupPickerModal}
        toggle={() => {
          setShowGroupPickerModal(false)
          setPendingGroupSelection(null)
          setGroupItems([])
          setInitialGroupSelectedItemIds([])
        }}
        selectedGroup={pendingGroupSelection}
        groupItems={groupItems}
        isLoading={isLoadingGroupItems}
        onConfirm={handleConfirmGroupSelection}
        onSelectAll={handleSelectAllGroupItems}
        initialSelectedItemIds={initialGroupSelectedItemIds}
      />
    </Card>
  )
}

export default Item2
